export const es = {
  nav: {
    dashboard: 'Panel',
    vehicles: 'Vehículos',
    leads: 'Leads',
    allLeads: 'Todos los Leads',
    conversations: 'Conversaciones',
    proposals: 'Propuestas',
    marketplace: 'Marketplace',
    newLead: 'Nuevo lead',
    newVehicle: 'Nuevo vehículo',
    financial: 'Financiero',
    management: 'Gestión',
    sellers: 'Vendedores',
    maintenance: 'Mantenimiento',
    users: 'Usuarios',
    settings: 'Configuración',
    settingsGeneral: 'General',
    settingsTheme: 'Tema',
    settingsDealership: 'Concesionario',
    settingsPaymentForms: 'Formas de Pago',
    settingsRoles: 'Roles y Permisos',
    settingsSub: {
      general: 'General',
      theme: 'Tema',
      dealership: 'Concesionario',
      paymentForms: 'Formas de pago',
      operation: 'Operación',
      leads: 'Leads',
      vehicleEvaluation: 'Evaluación de vehículos',
      operationPipeline: 'Embudo de ventas',
      operationPreparation: 'Embudo de preparación',
      leadsSources: 'Catálogo de medios',
      leadsMedia: 'Medios activos',
      roleAccess: 'Acceso por perfil',
      billing: 'Suscripción y facturación',
    },
    salesSection: 'Ventas',
    leadsSettingsSub: { kanban: 'Kanban', webhooks: 'Webhooks' },
    bottomNav: { sales: 'Ventas cerradas', pipeline: 'Embudo de ventas' },
    products: 'Productos/Servicios',
    more: 'Más',
    profile: 'Mi Perfil',
    logout: 'Salir',
    lightMode: 'Modo claro',
    darkMode: 'Modo oscuro',
    financialSub: {
      overview: 'Resumen',
      charges: 'Cargos',
      benefits: 'Beneficios',
      invoices: 'Facturas',
      payments: 'Pagos',
      commissions: 'Comisiones',
      commissionRules: 'Reglas de comisión',
      closures: 'Cierres',
      fiscalDocuments: 'Docs. fiscales',
    },
    sales: 'Ventas',
    salesSub: {
      closedDeals: 'Negocios cerrados',
      acceptedProposals: 'Propuestas aceptadas',
    },
    operation: 'Operación',
    operationSub: {
      postSale: 'Posventa',
      preparation: 'Preparación',
      deliveries: 'Entregas',
      postReceipt: 'Posrecepción',
      taskSettings: 'Configuración de tareas',
    },
    operationPipelineSettings: 'Flujo y prevenda',
    postSales: 'Posventa',
    postSalesSub: {
      salesPipeline: 'Pipeline de ventas',
      preparationPipeline: 'Pipeline de preparación',
      deliveries: 'Entregas',
      configureSalesPipeline: 'Configuración',
      postReceipt: 'Posrecepción',
      dashboard: 'Panel',
    },
    leadsSub: {
      all: 'Todos los Leads',
      report: 'Informe',
      conversations: 'Conversaciones',
      distribution: 'Distribución',
      settings: 'Configuración',
    },
    marketplaceSub: {
      integrations: 'Integraciones',
      publications: 'Publicaciones',
      history: 'Historial',
    },
  },

  roleAccess: {
    title: 'Acceso por perfil',
    subtitle: 'Defina qué menús y funciones puede acceder cada perfil.',
    loadError: 'Error al cargar permisos.',
    saveError: 'Error al guardar permisos.',
    saveSuccess: 'Permisos actualizados correctamente.',
    save: 'Guardar cambios',
    saving: 'Guardando...',
    ownerOnly: 'Solo el propietario puede gestionar el acceso por perfil.',
    ownerFullAccess: 'El propietario tiene acceso total y no puede ser restringido.',
    sectionRoot: 'Menú principal',
    roles: {
      owner: 'Propietario',
      manager: 'Gerente',
      salesperson: 'Vendedor',
      financial: 'Financiero',
      mechanic: 'Mecánico',
      viewer: 'Visualizador',
    },
  },

  myProfile: {
    title: 'Mi perfil',
    subtitle: 'Actualiza tus datos, foto y preferencias',
    tabs: {
      data: 'Detalles',
      photo: 'Foto',
      security: 'Seguridad',
    },
    name: 'Nombre completo',
    namePlaceholder: 'Tu nombre completo',
    email: 'Correo',
    emailPlaceholder: 'tu@email.com',
    phone: 'Teléfono',
    phoneCountryCode: 'Código de país',
    phoneArea: 'Código de área',
    phoneNumber: 'Número',
    phonePlaceholder: '999999999',
    phoneHelp: 'Usa el número que tu equipo utiliza en el día a día.',
    phoneRequired: 'El teléfono es obligatorio',
    cancel: 'Cancelar',
    save: 'Guardar cambios',
    saving: 'Guardando...',
    success: '¡Perfil actualizado con éxito!',
    nameRequired: 'El nombre es obligatorio',
    heroRole: 'Rol',
    heroStatus: 'Estado',
    heroLastLogin: 'Último acceso',
    heroCreatedAt: 'Cuenta creada',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    contextBackoffice: 'Backoffice',
    contextDealership: 'Concesionaria',
    roles: {
      owner: 'Propietario',
      manager: 'Gerente',
      salesperson: 'Vendedor',
      financial: 'Finanzas',
      mechanic: 'Mecánico',
      viewer: 'Visualizador',
    },
    photoTitle: 'Foto de perfil',
    photoDescription: 'Elige una imagen cuadrada para que tu perfil se vea genial en el encabezado.',
    photoUpload: 'Elegir foto',
    photoRemove: 'Quitar foto',
    photoHint: 'La imagen se guarda en este navegador y aparece en toda la app.',
    securityTitle: 'Seguridad y acceso',
    securityDescription: 'Resumen de tu cuenta y permisos actuales.',
    securityNeverLogin: 'Aún sin historial de acceso',
    securityActive: 'Cuenta activa',
    securityInactive: 'Cuenta inactiva',
  },


  userRegistration: {
    titleCreate: 'Nuevo usuario',
    titleEdit: 'Editar usuario',
    subtitleCreate: 'Registra un nuevo usuario en tu concesionario',
    subtitleEdit: 'Edita la información del usuario',
    back: 'Volver',
    cardTitle: 'Información del usuario',
    nameLabel: 'Nombre completo',
    namePlaceholder: 'Ingresa el nombre completo',
    emailLabel: 'Correo',
    emailPlaceholder: 'usuario@empresa.com',
    countryCodeLabel: 'Código de país',
    countryCodePlaceholder: '+34',
    areaLabel: 'Código de área',
    areaPlaceholder: '11',
    phoneLabel: 'Teléfono',
    phonePlaceholder: '99999-9999',
    userStatusLabel: 'Estado del usuario',
    active: 'Activo',
    inactive: 'Inactivo',
    roleLabel: 'Perfil *',
    loadingRoles: 'Cargando perfiles...',
    selectedRolePrefix: 'Perfil seleccionado:',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: 'Mínimo 6 caracteres',
    confirmPasswordLabel: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Confirma la contraseña',
    roleInfoPrefix: 'Perfil seleccionado:',
    cancel: 'Cancelar',
    submitCreate: 'Registrar usuario',
    submitEdit: 'Guardar cambios',
    successCreate: '¡Usuario registrado con éxito!',
    createError: 'Error al registrar el usuario. Inténtalo de nuevo.',
    validation: {
      nameRequired: 'El nombre es obligatorio',
      emailRequired: 'El correo es obligatorio',
      emailInvalid: 'Correo inválido',
      passwordRequired: 'La contraseña es obligatoria',
      passwordMin: 'La contraseña debe tener al menos 6 caracteres',
      confirmPasswordRequired: 'La confirmación de contraseña es obligatoria',
      passwordMismatch: 'Las contraseñas no coinciden',
      roleRequired: 'El perfil es obligatorio',
      areaRequired: 'El código de área es obligatorio',
      phoneRequired: 'El teléfono es obligatorio',
    },
  },

  userProfile: {
    title: 'Perfil del usuario',
    subtitle: 'Ver y editar la información del usuario',
    backToList: 'Volver a la lista',
    back: 'Volver',
    edit: 'Editar',
    notFoundTitle: 'Usuario no encontrado',
    notFoundDescription: 'No se pudo encontrar el usuario solicitado.',
    basicInfoTitle: 'Información básica',
    detailsTitle: 'Información detallada',
    editInfoTitle: 'Editar información',
    namePlaceholder: 'Juan Pérez',
    emailPlaceholder: 'juan@ejemplo.com',
    newPasswordLabel: 'Nueva contraseña (opcional)',
    newPasswordPlaceholder: 'Deje en blanco para mantener la contraseña actual',
    confirmNewPasswordLabel: 'Confirmar nueva contraseña',
    confirmNewPasswordPlaceholder: 'Confirme la nueva contraseña',
    phonesLabel: 'Teléfonos',
    noPhones: 'No hay números de teléfono registrados',
    noPhonesAdded: 'No se agregaron números de teléfono',
    addPhone: 'Agregar teléfono',
    addPhoneToStart: 'Haga clic en "Agregar teléfono" para comenzar',
    phoneItemLabel: 'Teléfono {{number}}',
    primaryBadge: 'Principal',
    makePrimary: 'Establecer como principal',
    countryCodeLabel: 'Código de país',
    countryCodePlaceholder: '+1',
    areaLabel: 'Código de área',
    areaPlaceholder: '11',
    phoneLabel: 'Teléfono',
    phonePlaceholder: '99999-9999',
    roleLabel: 'Perfil',
    selectProfile: 'Seleccione un perfil',
    userStatusLabel: 'Estado del usuario',
    createdAtLabel: 'Creado el',
    lastLoginLabel: 'Último acceso',
    profileDescriptionTitle: 'Descripción del perfil',
    successUpdate: '¡Perfil actualizado con éxito!',
    validation: {
      phonesRequired: 'Se requiere al menos un número de teléfono',
    },
  },

  dashboard: {
    title: 'Panel de Control',
    subtitle: 'Resumen de tu concesionario',
    error: {
      load: 'No se pudieron cargar los datos del panel',
    },
    actions: {
      refresh: 'Actualizar',
      refreshing: 'Actualizando...',
      tryAgain: 'Intentar de nuevo',
    },
    stats: {
      vehicles: 'Vehículos',
      leads: 'Leads',
      revenue: 'Ingresos',
      conversion: 'Conversión',
    },
    charts: {
      salesAndLeads: 'Ventas y Leads por Mes',
      sales: 'Ventas',
      leadStatus: 'Estado de Leads',
      noData: 'Sin datos disponibles',
    },
    recentLeads: {
      title: 'Leads Recientes',
      empty: 'Sin leads recientes',
    },
    analytics: {
      monthlyDescription: 'Comparativo mensual de generación de demanda y cierres.',
      statusDescription: 'Distribución actual de leads por estado comercial.',
      recentLeadsDescription: 'Últimas oportunidades recibidas por el equipo comercial.',
      units: 'Unidades',
      stockAging: {
        title: 'Stock Aging',
        description: 'Tiempo en patio por rango',
        ranges: {
          upTo15: '0-15 días',
          from16To30: '16-30 días',
          from31To60: '31-60 días',
          from61To90: '61-90 días',
          over90: '+90 días',
        },
      },
      leadSla: {
        title: 'Lead SLA',
        target: 'Meta de respuesta WhatsApp',
        firstResponse: '1ª respuesta',
        qualification: 'Calificación',
        followUp: 'Seguimiento',
      },
      salesFunnel: {
        title: 'Embudo de Ventas Completo',
        description: 'Conversión por etapa',
        leads: 'Leads',
        qualified: 'Calificados',
        proposals: 'Propuestas',
        negotiation: 'Negociación',
        closed: 'Ventas',
      },
      leaderboard: {
        title: 'Ranking de Vendedores',
      },
      preparation: {
        title: 'Cuellos de Botella de Preparación',
        defaultStage: 'Preparación',
        documentation: 'Documentación',
        service: 'Taller',
        detailing: 'Estética',
      },
    },
  },

  // Common actions
  actions: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    add: 'Agregar',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    clear: 'Limpiar',
    close: 'Cerrar',
    view: 'Ver',
    duplicate: 'Duplicar',
    loading: 'Cargando...',
    submit: 'Enviar',
    update: 'Actualizar',
  },

  salesPipeline: {
    title: 'Embudo de venta',
    subtitle:
      'La posición se calcula según el estado de la venta y la propuesta. Seleccione una venta para ver el embudo.',
    selectSale: 'Venta',
    selectPlaceholder: 'Seleccione una venta',
    loadSaleError: 'No se pudieron cargar los datos de la venta.',
    loadSalesError: 'No se pudo cargar la lista de ventas.',
    currentStageTitle: 'Posición actual',
    cancelledSale: 'Esta venta está cancelada. El embudo ilustrativo no aplica.',
    stagesExplainTitle: 'Qué significa cada etapa',
    stages: {
      first_contact: 'Primer contacto',
      qualification: 'Calificación',
      vehicle_interest: 'Interés en el vehículo',
      visit_test_drive: 'Visita / Prueba de manejo',
      proposal_sent: 'Propuesta enviada',
      negotiation: 'Negociación',
      proposal_approved: 'Propuesta aprobada',
      payment: 'Pago',
      sale_confirmed: 'Venta confirmada',
      preparation: 'Preparación',
      delivery: 'Entrega',
    },
    stageHelp: {
      first_contact:
        'Registro inicial del interés: origen del lead, datos de contacto y derivación al equipo comercial.',
      qualification:
        'Análisis de perfil, necesidad, presupuesto y encaje para orientar el vehículo adecuado.',
      vehicle_interest:
        'El cliente se centra en modelos concretos; se alinean precio, versión, equipamiento y stock.',
      visit_test_drive:
        'Visita al concesionario o prueba de manejo para vivir el vehículo y confirmar el interés.',
      proposal_sent:
        'Propuesta formal con valores, condiciones de pago y plazos enviada para revisión del cliente.',
      negotiation:
        'Ajustes de precio, entrada, permuta, accesorios o plazos hasta acercar oferta y expectativa.',
      proposal_approved:
        'El cliente acepta la propuesta; comienza la formalización y revisión documental previa al pago.',
      payment:
        'Cobro según lo acordado (cuotas, financiación, transferencias) hasta saldar el valor de la venta.',
      sale_confirmed:
        'La venta queda reconocida operativamente tras el pago o contrato; sigue la preparación del vehículo.',
      preparation:
        'Checklist posventa: trámites, revisión, detailing y accesorios para dejar el vehículo listo.',
      delivery:
        'Entrega al cliente con orientaciones de uso y cierre formal de este ciclo de venta.',
    },
  },

  financialSales: {
    title: 'Ventas',
    tabs: {
      list: 'Lista',
      pipeline: 'Embudo de venta',
    },
    filters: 'Filtros',
    status: 'Estado',
    startDate: 'Fecha inicial',
    endDate: 'Fecha final',
    startDatePlaceholder: 'Seleccione la fecha inicial',
    endDatePlaceholder: 'Seleccione la fecha final',
    clearFilters: 'Limpiar filtros',
    loadError: 'Error al cargar ventas',
    empty: 'No se encontraron ventas',
    statusAll: 'Todos',
    statusLabels: {
      open: 'Abierta',
      waiting_payment: 'Esperando pago',
      paid: 'Pagada',
      in_preparation: 'En preparación',
      ready_for_delivery: 'Lista para entrega',
      delivered: 'Entregada',
      pending: 'Pendiente',
      confirmed: 'Confirmada',
      cancelled: 'Cancelada',
    },
    viewProposal: 'Ver propuesta',
    proposalCardTitle: 'Propuesta',
    saleItemsTitle: 'Ítems adicionales de la venta',
    saleItemDescription: 'Descripción',
    saleItemQty: 'Cant.',
    saleItemUnit: 'Unitario',
    saleItemTotal: 'Total',
    paymentFormLabel: 'Forma de pago',
    paymentFormPlaceholder: 'Seleccione',
    paymentOptionLabel: 'Opción de la forma',
    paymentOptionPlaceholder: 'Opcional',
    paymentOptionNone: 'Ninguna',
    paymentFormColumn: 'Forma de pago',
    saleChargesTitle: 'Cargos financieros',
    saleChargesEmpty: 'No hay cargos registrados en esta venta.',
    saleChargeNameColumn: 'Cargo',
    saleChargeValueColumn: 'Importe',
    saleBenefitsTitle: 'Beneficios de la venta',
    saleBenefitsEmpty: 'No hay beneficios registrados en esta venta.',
    saleBenefitNameColumn: 'Beneficio',
    saleBenefitValueColumn: 'Valor aplicado',
    customerCard: {
      title: 'Cliente',
      email: 'Correo',
      phone: 'Teléfono',
      address: 'Dirección',
      notes: 'Notas',
    },
    vehicleCard: {
      title: 'Vehículo',
      plate: 'Patente',
    },
    salespersonCard: {
      title: 'Vendedor',
    },
    leadSnapshot: {
      title: 'Historial del lead (instantánea)',
      capturedAt: 'Registrado el',
      interestsTitle: 'Intereses en vehículos',
      legacyVehicleTitle: 'Vehículo vinculado al lead (legado)',
      preferencesTitle: 'Preferencias de búsqueda',
      proposalsTitle: 'Propuestas del lead',
      contactsTitle: 'Contactos del lead',
      emptySnapshot:
        'Instantánea del lead no disponible. Cree o actualice una propuesta para completar estos datos.',
      proposalColumns: {
        status: 'Estado',
        value: 'Valor',
        final: 'Final',
        vehicle: 'Vehículo',
        date: 'Fecha',
      },
      proposalStatus: {
        open: 'Abierta',
        in_negotiation: 'En negociación',
        approved: 'Aprobada',
        rejected: 'Rechazada',
        expired: 'Expirada',
      },
    },
    leadSnapshotValidation: {
      title: 'Revisión',
      vehicleNotInInterests:
        'El vehículo de esta venta no figura en la lista de intereses capturada del lead.',
      documentMismatch:
        'El documento del cliente difiere del documento en la instantánea del lead.',
      proposalVehicleMismatch:
        'El vehículo de la propuesta vinculada difiere del vehículo actual de esta venta.',
    },
    commissions: {
      edit: 'Editar valores',
      base: 'Base',
      percent: 'Porcentaje (%)',
      calculatedValue: 'Importe acordado / pagado',
      fixedValueColumn: 'Importe fijo',
      fixedValueLabel: 'Importe fijo',
      mixedBreakdown: 'Importe {{fixed}} + {{percent}} (total en {{totalPercent}})',
      originalColumn: 'Original (regla)',
      agreedColumn: 'Acordado',
      differenceColumn: 'Diferencia',
      saveSuccess: 'Comisión actualizada',
      saveLocalSuccess: 'Cambios aplicados en pantalla. Se guardan al marcar como pagada.',
      saveCommissionEditSuccess:
        'Valores de comisión actualizados en pantalla (definitivo al marcar como pagada). Bonos guardados en el servidor.',
      saveError: 'No se pudo actualizar la comisión',
      onlyPending: 'Solo se pueden editar comisiones pendientes',
      invalidValues: 'Valores no válidos. Use números positivos.',
      mandatoryReadonly:
        'Esta comisión es obligatoria por configuración y no se puede editar.',
      mandatoryBadge: 'Obligatoria',
      remove: 'Eliminar',
      confirmStepCta: 'Confirmar comisiones',
      confirmNoCommissionsCta: 'Comisiones concluidas',
      stepConfirmHint:
        'Confirme tras revisar (o si no hay líneas) para desbloquear la siguiente fase posventa.',
      stepConfirmedHint: 'Comisiones confirmadas el {{date}}.',
      confirmStepSuccess: 'Paso de comisiones confirmado.',
      confirmStepError: 'No se pudo confirmar el paso de comisiones.',
      deleteDialogTitle: 'Eliminar comisión',
      deleteDialogDescription:
        'Se eliminará la línea de esta venta. Si el paso ya estaba confirmado, se anulará esa confirmación.',
      deleteSuccess: 'Comisión eliminada.',
      deleteError: 'No se pudo eliminar la comisión.',
      summaryVehicleValue: 'Valor del vehículo',
      summaryCommissionsTotal: 'Total de comisiones',
      summaryVehicleMinusCommissions: 'Valor del vehículo - comisiones',
      editAfterConfirm: 'Editar comisiones',
      lockedAfterPreparation: 'Las comisiones quedan bloqueadas tras enviarla a preparación.',
      payRequiresCommissionConfirmation:
        'Confirme las comisiones de esta venta antes de marcarlas como pagadas.',
      paymentRuleAfterInvoice: 'Tras facturación',
      paymentRuleAfterPayment: 'Tras el pago del cliente',
      bonusColumn: 'Bonus',
      bonusValuesColumn: 'Valores de bonus',
      totalWithBonusesColumn: 'Total (c/ bonus)',
      bonusSectionTitle: 'Bonos de esta comisión',
      bonusAmountLabel: 'Importe',
      bonusLabelPlaceholder: 'Descripción del bono',
      bonusAdd: 'Añadir bono',
      bonusRemove: 'Quitar',
      bonusInvalid: 'Indique la descripción y un importe válido para el bono.',
      bonusAddSuccess: 'Bono añadido.',
      bonusRemoveSuccess: 'Bono eliminado.',
      bonusSaveError: 'No se pudo guardar el bono.',
    },
    commissionSettings: {
      title: 'Comisiones en las ventas',
      applyStoreRules: 'Incluir reglas de tienda y gerente en todas las ventas',
      applyStoreHint:
        'Si está activo, las reglas con “Aplicable a” Tienda o Gerente entran en la generación automática de comisiones en cada venta.',
      saveSuccess: 'Configuración guardada.',
      saveError: 'No se pudo guardar la configuración.',
    },
    fiscalExport: {
      title: 'Exportación fiscal (contabilidad)',
      description:
        'CNPJ de la concesión, datos fiscales y dirección de la sucursal del vehículo, cliente y vehículo para NF-e (sin XML). Corrija pendientes y descargue PDF o JSON.',
      missingTitle: 'Datos faltantes',
      readyHint: 'Datos mínimos completos para exportar.',
      downloadJson: 'Descargar JSON',
      downloadPdf: 'Descargar PDF',
      editDealership: 'Sucursales y fiscal por sucursal',
      editVehicle: 'Editar vehículo',
      editCustomer: 'Editar cliente',
      loadError: 'No se pudo cargar la exportación fiscal.',
      pdfLoadError: 'No se pudo generar el PDF fiscal.',
      missing: {
        issuerCnpj: 'CNPJ del emisor',
        issuerLegalName: 'Razón social / nombre comercial del emisor',
        customerAddressStreet: 'Calle del cliente',
        customerAddressNumber: 'Número del cliente',
        customerAddressCity: 'Ciudad del cliente',
        customerAddressState: 'UF del cliente',
        customerAddressZip: 'CEP del cliente',
        branchLinkVehicle: 'Sucursal: vincule el vehículo de la venta a una sucursal con dirección completa',
        branchStateRegistration: 'IE de la sucursal (datos de la sucursal)',
        branchTaxRegime: 'Régimen tributario de la sucursal (datos de la sucursal)',
        branchName: 'Nombre de la sucursal',
        branchNeighborhood: 'Barrio de la sucursal',
        branchAddressStreet: 'Calle de la sucursal',
        branchAddressNumber: 'Número de la sucursal',
        branchAddressCity: 'Ciudad de la sucursal',
        branchAddressState: 'UF de la sucursal',
        branchAddressZip: 'CEP de la sucursal',
        customerDocument: 'CPF/CNPJ del cliente',
        customerCpf: 'CPF del cliente (11 dígitos)',
        customerCnpj: 'CNPJ del cliente (14 dígitos)',
        customerName: 'Nombre del cliente',
        customerEmail: 'Correo del cliente',
        customerPhone: 'Teléfono del cliente',
        vehiclePlate: 'Placa',
        vehicleChassis: 'Chasis',
        vehicleRenavam: 'RENAVAM',
        vehicleFuel: 'Combustible',
        vehicleColor: 'Color',
        itemNcm: 'NCM (predeterminado en sucursal del vehículo, concesión o FISCAL_DEFAULT_NCM)',
        itemCfop: 'CFOP (predeterminado en sucursal del vehículo, concesión o FISCAL_DEFAULT_CFOP)',
      },
      customerEdit: {
        title: 'Editar cliente',
        save: 'Guardar',
        back: 'Volver',
        saveSuccess: 'Cliente actualizado.',
        saveError: 'No se pudo guardar el cliente.',
        loadError: 'No se pudo cargar el cliente.',
      },
    },
    commissionRuleForm: {
      stepBasic: 'Configuración básica',
      stepAdvanced: 'Reglas avanzadas',
      stepValidity: 'Vigencia',
      activeRuleLabel: 'Regla activa',
      nameRequired: 'Indique el nombre de la regla. Este campo es obligatorio.',
      ruleBonusTitle: 'Bonos de la regla',
      ruleBonusHint:
        'Importes predeterminados copiados a cada comisión generada por esta regla. En la venta se pueden ajustar en Editar valores.',
      salespersonLabel: 'Vendedor de la regla (opcional)',
      salespersonAll: 'Todos los vendedores',
      salespersonHint: 'Solo aplica si el vendedor de la venta coincide.',
      listSalespersonColumn: 'Vendedor',
      sharedAmongLabel: 'Regla compartida entre vendedores',
      sharedAmongHint:
        'Si está activo, esta regla de vendedor aplica a cualquier vendedor de la venta.',
      sharedBadge: 'Compartida',
      paymentFormHint:
        'Si elige una forma de pago, la regla solo se considera cuando la venta incluya esa forma (en los pagos de la propuesta).',
      tierFixBeforeContinue:
        'Ajuste las franjas de valor: rangos inválidos o superpuestos. No puede continuar ni guardar hasta corregirlos.',
      tierInvalidRange: 'El máximo debe ser mayor que el mínimo.',
      tierOverlap: 'Esta franja se superpone con otra. Ajuste los límites para que no se crucen.',
      tierEmpty: 'Añada al menos una franja de valor.',
      vigenceStatusNone: 'Sin vigencia',
      vigenceStatusFuture: 'Futura',
      vigenceStatusExpired: 'Caducada',
      vigenceStatusActive: 'Vigente',
      nameField: 'Nombre',
      namePlaceholder: 'Ej.: Comisión estándar vendedor',
      descriptionField: 'Descripción',
      descriptionPlaceholder: 'Describa el objetivo de esta regla...',
      commissionKindLabel: 'Tipo de comisión',
      calculationModeLabel: 'Modo de cálculo',
      percentSingle: 'Porcentaje fijo',
      tierMode: 'Franjas de valor',
      percentValueLabel: 'Porcentaje (%)',
      tiersTitle: 'Franjas de valor',
      addTierRow: 'Añadir franja',
      tierMin: 'Valor mínimo',
      tierMax: 'Valor máximo (opcional)',
      tierPercent: 'Porcentaje (%)',
      tierHintEmpty: 'Pulse "Añadir franja" para crear franjas de comisión.',
      fixedBlockLabel: 'Importe fijo',
      calculationBase: 'Base de cálculo',
      calcBaseVehicle: 'Valor del vehículo',
      calcBaseProfit: 'Beneficio',
      calcBaseFinanced: 'Importe financiado',
      applicableToField: 'Aplicable a',
      paymentRuleField: 'Regla de pago',
      mixedOption: 'Mixto (% + fijo)',
      vehicleTypeField: 'Tipo de vehículo',
      vehicleAll: 'Ambos',
      vehicleNew: 'Nuevo',
      vehicleUsed: 'Usado',
      paymentFormField: 'Forma de pago',
      paymentPlaceholder: 'Seleccione una forma de pago (opcional)',
      paymentNone: 'Ninguna',
      maxCommissionField: 'Tope máximo de comisión',
      maxCommissionPlaceholder: 'Sin límite',
      maxCommissionHelp: 'Deje en blanco para no limitar la comisión.',
      startAt: 'Fecha de inicio',
      endAt: 'Fecha de fin',
      validityHint: 'Deje las fechas en blanco para una regla sin fin de vigencia.',
      startPlaceholder: 'Seleccione fecha y hora de inicio',
      endPlaceholder: 'Seleccione fecha y hora de fin',
      createRuleCta: 'Crear regla',
      updateRuleCta: 'Actualizar regla',
    },
    commissionRulesPage: {
      listSubtitle: 'Gestione porcentajes, franjas y vigencia de las comisiones de la tienda.',
      registeredRules: 'Reglas registradas ({{count}})',
      emptyList: 'No se encontraron reglas de comisión.',
      loadError: 'No se pudieron cargar las reglas de comisión.',
      duplicateSuccess: 'Regla de comisión duplicada correctamente.',
      duplicateError: 'No se pudo duplicar la regla.',
      deleteSuccess: 'Regla eliminada correctamente.',
      deleteError: 'No se pudo eliminar la regla.',
      deleteTitle: 'Confirmar eliminación',
      deleteDescription:
        '¿Seguro que desea eliminar la regla "{{name}}"? Esta acción no se puede deshacer.',
      duplicateTitle: 'Duplicar regla',
      duplicateDescription:
        '¿Duplicar la regla "{{name}}"? La nueva regla se creará como inactiva.',
      formTitleNew: 'Nueva regla de comisión',
      formTitleEdit: 'Editar regla de comisión',
      formSubtitleNew: 'Complete los datos de la nueva regla de comisión.',
      formSubtitleEdit: 'Editando: {{name}}',
      filtersTitle: 'Filtros',
      filterStatus: 'Estado',
      filterType: 'Tipo',
      filterApplicable: 'Aplicable a',
      filterVigence: 'Vigencia',
      allMasc: 'Todos',
      allFem: 'Todas',
      activeRules: 'Activas',
      inactiveRules: 'Inactivas',
      vigenceCurrent: 'Vigente',
      vigencePast: 'Caducada',
      colName: 'Nombre',
      colType: 'Tipo',
      colValue: 'Valor / %',
      colApplicable: 'Aplicable a',
      colStatus: 'Estado',
      colVigence: 'Vigencia',
      colActions: 'Acciones',
      statusOn: 'Activa',
      statusOff: 'Inactiva',
      bonusDash: '—',
      saveRuleError: 'No se pudo guardar la regla de comisión.',
      createSuccess: 'Regla de comisión creada correctamente.',
      updateSuccess: 'Regla de comisión actualizada correctamente.',
    },
    commissionRuleEvaluation: {
      sectionTitle: 'Reglas activas en esta venta',
      notApplicable: 'Regla no aplicable',
      enabledOnSale: 'Habilitada en esta venta',
      onSaleColumn: 'En la venta',
      ruleColumn: 'Regla',
      statusColumn: 'Situación',
      applicableToColumn: 'Aplicable a',
      availableToAddHint: 'Disponible para añadir manualmente.',
      reasons: {
        inactive: 'Regla inactiva.',
        vehicle_type: 'El tipo de vehículo de la venta no coincide con la regla.',
        payment_form: 'La forma de pago de la venta no coincide con la regla.',
        vigence_before_start: 'La vigencia de la regla aún no ha comenzado.',
        vigence_after_end: 'La vigencia de la regla ya finalizó.',
        salesperson_scope: 'El vendedor de la venta no coincide con el vendedor de la regla.',
      },
      info: {
        manager_dealership_auto_disabled:
          'No entra en la generación automática mientras la opción de incluir reglas de tienda y gerente esté desactivada; aún puede añadirse manualmente.',
      },
      applicableTo: {
        salesperson: 'Vendedor',
        manager: 'Gerente',
        dealership: 'Tienda',
      },
      mandatoryWillApplyHint:
        'Regla obligatoria: se tendrá en cuenta en la generación automática cuando se cumplan los criterios.',
      noRulesInSelect: 'Ninguna regla disponible',
    },
    preparationCostsTitle: 'Costos de preparación',
    preparationCostsAdd: 'Añadir costo',
    preparationCostsDescription: 'Descripción',
    preparationCostsDescriptionPlaceholder: 'Descripción del costo',
    preparationCostsAmount: 'Importe',
    preparationCostsType: 'Tipo',
    preparationCostsTypePlaceholder: 'Seleccione',
    preparationCostsEmpty: 'No hay costos de preparación registrados',
    costTypes: {
      mechanical: 'Mecánica',
      bodywork: 'Chapa y pintura',
      documentation: 'Documentación',
      cleaning: 'Limpieza',
      accessories: 'Accesorios',
      other: 'Otros',
    },
    paymentsTab: {
      summaryTitle: 'Resumen de pagos',
      finalValue: 'Importe final de la venta',
      totalConfirmed: 'Recibido (confirmado)',
      totalPending: 'Planificado (pendiente)',
      remaining: 'Pendiente de cobrar',
      fullyPaidBadge: 'Importe total recibido',
      proposalReference: 'Condiciones de pago (propuesta)',
      installmentsCount: '{{count}} cuota(s)',
      dueDate: 'Vencimiento',
      amount: 'Importe',
      status: 'Estado',
      tradeTitle: 'Vehículos de permuta (propuesta)',
      tradeMismatchHint:
        'Si el valor tasado difiere de la propuesta, cancele esta venta y cree una nueva propuesta con los importes correctos.',
      vehicle: 'Vehículo',
      offeredValue: 'Valor en la propuesta',
      cancelSaleCta: 'Cancelar venta y renegociar',
      cancelSaleHint: 'Para corregir importes tras divergencia en permuta o en el acuerdo, cancele la venta y cree una nueva propuesta.',
      cancelSaleTitle: 'Cancelar venta',
      cancelSaleDescription:
        'La venta quedará cancelada. Cree una nueva propuesta para el cliente con los importes actualizados.',
      cancelSaleConfirm: 'Cancelar venta',
      cancelSaleSuccess: 'Venta cancelada',
      cancelSaleError: 'No se pudo cancelar la venta',
      chargesTitle: 'Cargos en la venta',
      chargeValue: 'Importe',
      discountPct: 'Descuento %',
      invoicePayments: 'Pagos de facturas',
      invoiceNumber: 'Factura #{{n}}',
      date: 'Fecha',
      method: 'Método',
      saleReceipts: 'Cobros de la venta',
      addReceipt: 'Añadir cobro',
      paidDate: 'Fecha de pago',
      registerAsPending: 'Registrar como pendiente (aún no cobrado)',
      noReceipts: 'No hay cobros registrados',
      statusPending: 'Pendiente',
      statusConfirmed: 'Confirmado',
      statusCancelled: 'Cancelado',
      splitTitle: 'Dividir cobro',
      splitDescription: 'Indique dos importes que sumen el total de la línea original. Las nuevas líneas quedarán pendientes.',
      splitPart1: 'Importe parte 1',
      splitPart2: 'Importe parte 2',
      splitConfirm: 'Dividir',
      deleteTitle: 'Eliminar cobro',
      deleteDescription: '¿Eliminar esta línea pendiente? Esta acción no se puede deshacer.',
      deleteSuccess: 'Cobro eliminado',
      deleteError: 'No se pudo eliminar',
      splitSuccess: 'Cobro dividido',
      splitError: 'No se pudo dividir',
      savePaymentSuccess: 'Cobro actualizado',
      savePaymentError: 'No se pudo actualizar',
      addPaymentSuccess: 'Cobro registrado',
      addPaymentError: 'No se pudo registrar',
      invalidAmount: 'Introduzca un importe numérico válido',
      invalidDiscount: 'El descuento debe estar entre 0 y 100%',
      chargeSaveSuccess: 'Cargo actualizado',
      chargeSaveError: 'No se pudo actualizar el cargo',
    },
    saleDetailDates: {
      performedOn: 'Realizada el',
      registeredOn: 'Registrada el',
      saleDateField: 'Fecha de la venta',
      registeredAtField: 'Fecha de registro',
    },
    saleDetailsTabs: {
      details: 'Detalles',
      administrative: 'Administrativo',
      preparation: 'Preparación',
      operation: 'Flujo operativo',
      timeline: 'Línea de tiempo',
      financial: 'Financiero',
      commissions: 'Comisiones',
      payments: 'Pagos',
      documents: 'Documentos',
    },
    saleOnboarding: {
      title: 'Camino hasta la bandeja de preparación',
      subtitle:
        'Siga el orden: el siguiente paso solo se habilita cuando los anteriores estén completos.',
      loading: 'Cargando progreso…',
      syncing: 'Sincronizando con el servidor…',
      lockedStepHint: 'Complete primero las etapas anteriores.',
      tabLockedToast: 'Complete las etapas anteriores para abrir esta pestaña.',
      steps: {
        payment: 'Pago',
        documentation: 'Documentación',
        commissions: 'Comisiones',
        invoicing: 'Facturación',
        pipeline: 'Listo para preparación',
      },
      sendCta: 'Enviar a la bandeja de preparación',
      sending: 'Enviando…',
      sendSuccess: 'Venta enviada a preparación.',
      sendError: 'No se pudo enviar al flujo.',
      hintCompleteRequirements:
        'Complete el pago, documentación, comisiones obligatorias, facturación (documento fiscal o factura) y el checklist posventa.',
      inPipeline: 'Esta venta ya está en preparación o en una etapa posterior.',
      requirementsTitle: 'Requisitos de documentación y contratos',
      customerDocsSection: 'Documentos obligatorios',
      contractsSection: 'Contratos obligatorios',
      attachCustomer: 'Vínculo: ficha del cliente',
      attachSale: 'Vínculo: documentos de la venta',
      selectDocument: 'Seleccione un archivo',
      linkDocument: 'Vincular',
      linking: 'Vinculando…',
      docLinked: 'Documento vinculado.',
      docLinkError: 'No se pudo vincular el documento.',
      pickDocumentFirst: 'Seleccione un documento de la lista.',
      uploadFirstHint: 'Suba el archivo abajo y vincúlelo aquí.',
      uploadCustomerTitle: 'Subir documento del cliente',
      openTemplate: 'Abrir plantilla de referencia',
      signDate: 'Fecha de firma',
      signedPdfOptional: 'PDF firmado (opcional)',
      optional: 'Opcional',
      none: 'Ninguno',
      saving: 'Guardando…',
      confirmSignature: 'Registrar firma',
      contractSigned: 'Firma registrada.',
      contractSignError: 'No se pudo registrar la firma.',
      pickSignDate: 'Indique la fecha de la firma.',
    },
    saleDocumentation: {
      tabSaleDocs: 'Documentos de la venta',
      tabVehicle: 'Documentos del vehículo',
      tabContracts: 'Contratos firmados',
      saleUploadTitle: 'Subir documentos',
      saleListTitle: 'Documentos de la venta',
      documentationAccordionChecklist: 'Checklist de documentación',
      documentationAccordionUploadsHint:
        'Cada sección muestra los archivos ya subidos para esta venta y permite añadir más.',
      slotFileCount: '{{count}} archivo(s)',
      slotUploadedListLabel: 'Archivos de esta venta (este tipo)',
      slotNoFilesYet: 'Aún no hay archivos de este tipo.',
      checklistTitle: 'Checklist de documentación',
      vehicleMandatoryTitle: 'Archivos de documentación de esta venta',
      vehicleListTitle: 'Documentos del registro del vehículo',
      vehicleRegistryHint:
        'Solo documentos ya guardados en la ficha del vehículo. Para el trámite de esta venta, use la pestaña Documentos de la venta.',
      vehicleRegistryEmpty: 'No hay documentos en el registro del vehículo.',
      uploadSlot: 'Subir archivo',
      readOnlyHint: 'Sin permiso para editar.',
      noVehicle: 'Esta venta no tiene vehículo vinculado.',
      noContracts: 'No hay plantillas de contrato configuradas.',
      uploadSaleContractTitle: 'Contrato firmado (archivo)',
      uploadSignedContract: 'Subir PDF del contrato firmado',
      signedBadge: 'Firmado',
      pendingBadge: 'Pendiente',
      updateSignature: 'Actualizar firma',
      invoiceSyncedHint: 'Se completa automáticamente con NF-e autorizada o factura emitida.',
      checklistSaved: 'Checklist actualizado.',
      checklistCleared: 'Ítem desmarcado.',
      checklistError: 'No se pudo actualizar el checklist.',
      deleteError: 'No se pudo eliminar el documento.',
      checklistUploadRequiredHint:
        'Solo puede marcar un ítem después de subir el archivo correspondiente. La factura se sincroniza sola.',
      checklistBadgeRequired: 'Obligatorio en esta etapa',
      checklistBadgeRecommended: 'Recomendado',
      checklistBadgeSend: 'Obligatorio para enviar a preparación',
      checklistAtpvHint:
        'En el Detran puede valer ATPV-e; para seguridad jurídica conserve prueba con dos firmas (recibo, TED/PIX, contrato de compraventa, etc.).',
      pjCorporateBanner:
        'Persona jurídica: suba CNPJ, estatuto/contrato social y documento del responsable en las tarjetas superiores (obligatorio para avanzar).',
      slotOptionalHint: 'opcional en esta etapa',
      checklistKeys: {
        buyer_id: 'Documento del comprador (RG/CPF o CNPJ)',
        address_proof: 'Comprobante de domicilio',
        atpv_signed: 'ATPV / prueba jurídica (dos firmas)',
        invoice_issued: 'Factura emitida',
        inspection_done: 'Inspección realizada',
        transfer_fee_paid: 'Tasa de transferencia pagada',
        sent_to_dispatcher: 'Transferencia enviada al gestor',
      },
      slotRgCpf: 'RG y CPF',
      slotCnpj: 'CNPJ',
      slotArticles: 'Contrato social',
      slotResponsible: 'Documento del responsable',
      slotAddressProof: 'Comprobante de domicilio',
      slotAtpv: 'ATPV firmada',
      slotInspection: 'Informe de inspección',
      slotPaymentFees: 'Comprobantes de pagos y tasas',
      slotDebts: 'Quita de deudas (IPVA, multas)',
      slotTransferFee: 'Comprobante tasa de transferencia',
      slotDispatcherProof: 'Comprobante envío al gestor',
      documentUpload: {
        defaultLabel: 'Subir documento',
        selectFile: 'Seleccionar archivo',
        changeFile: 'Elegir otro',
        cancelSelection: 'Cancelar',
        confirmUpload: 'Enviar documento',
        uploading: 'Enviando…',
        previewPdf: 'Vista previa PDF',
        previewOther: 'Sin vista previa para este tipo. Revise el nombre del archivo y envíe.',
        tempFailed: 'Falló la subida temporal del archivo',
        saleIdRequired: 'saleId es obligatorio para subir documentos de esta entidad',
        invalidTempResponse: 'Respuesta de subida inválida',
      },
    },
    saleLifecycle: {
      phases: {
        payment: 'Pago',
        documentation: 'Documentación',
        commissions: 'Comisiones',
        invoicing: 'Facturación',
        ready_for_preparation: 'Listo para preparación',
        quality_control: 'Control de calidad',
        ready_for_delivery: 'Listo para entrega',
      },
      lifecycleChecklistsTitle: 'Checklist por fase',
      lifecycleOpenTab: 'Abrir fase',
      lifecycleDone: 'Completado',
      lifecyclePending: 'Pendiente',
      lifecycleCancelledHint: 'Venta cancelada — sin checklist de ciclo.',
      administrativeAdvancedTitle: 'Etapas administrativas (avanzado)',
      administrativeTitle: 'Etapas administrativas',
      administrativeField: 'Etapa administrativa',
      macroPreparationField: 'Etapa de preparación (macro)',
      preparationTitle: 'Tareas de preparación',
      timelineTitle: 'Línea de tiempo',
      saveStages: 'Guardar etapas',
      stagesSaved: 'Etapas actualizadas',
      stagesError: 'No se pudieron guardar las etapas',
      noTasks: 'Sin tareas. Use “Iniciar preparación” cuando la venta esté pagada para generar el checklist.',
      taskStep: 'Etapa',
      taskStatus: 'Estado',
      saveTask: 'Guardar',
      taskSaved: 'Tarea actualizada',
      taskError: 'Error al actualizar la tarea',
      timelineEmpty: 'Sin eventos',
      timelineLoadError: 'Error al cargar la línea de tiempo',
      adminStages: {
        sale_created: 'Venta creada',
        documentation_pending: 'Documentación pendiente',
        documentation_received: 'Documentación recibida',
        financing_in_progress: 'Financiación en curso',
        financing_complete: 'Financiación completada',
        commission_pending: 'Comisión pendiente',
        commission_complete: 'Comisión liquidada',
        ready_for_preparation: 'Listo para preparación',
      },
      prepStages: {
        not_started: 'No iniciada',
        preparation_pending: 'Preparación pendiente',
        mechanical_check: 'Revisión mecánica',
        detailing: 'Detallado',
        accessories_installation: 'Accesorios',
        document_transfer: 'Transferencia documental',
        delivery_scheduled: 'Entrega programada',
        completed: 'Completada',
      },
      taskStatuses: {
        pending: 'Pendiente',
        in_progress: 'En curso',
        completed: 'Completada',
        skipped: 'Omitida',
      },
      stepKeys: {
        mechanical_check: 'Revisión mecánica',
        detailing: 'Detallado',
        accessories_installation: 'Accesorios',
        document_transfer: 'Documentación / transferencia',
        delivery_scheduled: 'Entrega programada',
        other: 'Otro',
      },
      timelineEventTitles: {
        lead_history: 'Actividad del lead',
        proposal_created: 'Propuesta creada',
        proposal_sent: 'Propuesta enviada',
        proposal_approved: 'Propuesta aprobada',
        sale_created: 'Venta registrada',
        sale_status_history: 'Estado de la venta',
        entity_document: 'Documento (venta)',
        vehicle_entity_document: 'Documento (vehículo)',
        sale_payment_recorded: 'Pago de la venta',
        commission: 'Comisión',
        sale_cost: 'Costo de preparación',
        preparation_task_created: 'Tarea de preparación',
        preparation_task_completed: 'Tarea completada',
        operational_stage_change: 'Etapa operacional',
        preparation_kanban_change: 'Tablero de preparación',
        checklist_item_change: 'Checklist',
      },
    },
  },

  operation: {
    stages: {
      pos_venda: 'Posventa',
      preparacao: 'Preparación',
      entrega: 'Entrega',
      pos_recebimento: 'Posrecepción',
      concluido: 'Completado',
    },
    postSale: {
      title: 'Posventa',
      subtitle: 'Administración y finanzas antes de preparar el vehículo.',
    },
    preparation: {
      title: 'Preparación',
      subtitle: 'Kanban del taller — arrastre las tarjetas.',
    },
    preparationDetail: {
      title: 'Detalle de preparación',
      subtitle: 'Vista operativa del vehículo en preparación.',
      backToBoard: 'Volver al kanban',
      loadError: 'No se pudo cargar el detalle de preparación.',
      notFound: 'Detalle de preparación no encontrado.',
      vehicleSectionTitle: 'Datos del vehículo',
      vehicleLabel: 'Vehículo',
      plate: 'Matrícula',
      year: 'Año',
      mileage: 'Kilometraje',
      customer: 'Cliente',
      kanbanColumn: 'Columna del kanban',
      operationalCommentLabel: 'Comentario de operación',
      operationalCommentPlaceholder: 'Registre observaciones sobre el avance de esta operación.',
      timeInColumn: 'Tiempo en esta columna',
      columnSince: 'Entrada en la columna',
      checklistSectionTitle: 'Checklist de preparación',
      checklistProgress: '{{done}} de {{total}} completados',
      saveChecklist: 'Guardar checklist',
      checklistSaved: 'Checklist actualizado.',
      checklistError: 'No se pudo actualizar el checklist.',
      tasksSectionTitle: 'Tareas de preparación',
      selectAssignee: 'Seleccione un responsable',
      onlyUnassigned: 'Aplicar solo a tareas sin responsable',
      applyAssigneeToFlow: 'Aplicar responsable al flujo',
      assigneeSaved: 'Responsable de la tarea actualizado.',
      assigneeError: 'No se pudo actualizar el responsable.',
      bulkAssignSaved: 'Responsable aplicado a las tareas.',
      bulkAssignError: 'No se pudo aplicar responsable a las tareas.',
      saveAllSuccess: 'Cambios guardados con éxito.',
      saveAllError: 'No se pudieron guardar los cambios.',
      deliveryDateLabel: 'Fecha de entrega',
      deliveryDatePlaceholder: 'Seleccionar fecha y hora',
      deliveryAtSaved: 'Fecha de entrega programada.',
      saveAll: 'Guardar',
      confirmDelivery: 'Confirmar entrega',
      confirmDeliveryTitle: 'Confirmar entrega del vehículo',
      confirmDeliveryDescription: '¿Está seguro de que desea finalizar esta entrega? Esto marcará la venta como entregada y el vehículo como vendido.',
      confirmDeliveryWarning: 'Tras confirmar, el vehículo se considerará entregado y la venta se finalizará.',
      confirmDeliveryConfirm: 'Sí, confirmar entrega',
      confirmDeliveryCancel: 'Cancelar',
      deliveryConfirmed: '¡Entrega confirmada con éxito!',
      deliveryConfirmError: 'No se pudo confirmar la entrega.',
      noTasks: 'No hay tareas de preparación registradas.',
      unassigned: 'Sin responsable',
      tabFlow: 'Flujo',
      tabDocuments: 'Documentos',
      tabComments: 'Comentarios',
      documentsTitle: 'Documentos de preparación',
      documentUploaded: 'Documento subido con éxito.',
      noDocuments: 'No hay documentos subidos.',
      uploadedDocuments: '{{count}} documento(s) subido(s)',
      saveComment: 'Guardar comentario',
      commentSaved: 'Comentario guardado.',
    },
    deliveries: {
      title: 'Entregas',
      subtitle: 'Vehículos listos para entrega.',
    },
    postReceipt: {
      title: 'Posrecepción',
      subtitle: 'Seguimiento después de la entrega.',
    },
    loadError: 'No se pudieron cargar las ventas.',
    refresh: 'Actualizar',
    list: {
      date: 'Fecha',
      customer: 'Cliente',
      vehicle: 'Vehículo',
      finalValue: 'Valor final',
      progress: 'Checklist',
      details: 'Detalles',
      actions: 'Acciones',
      pageOf: 'Página {{page}} de {{total}}',
    },
    empty: 'No hay ventas en esta etapa.',
    salesInStage: 'Ventas en esta etapa',
    value: 'Valor',
    checklistProgress: '{{pct}}% del checklist',
    advance: 'Avanzar etapa',
    advanceOk: 'Etapa actualizada.',
    advanceError: 'No se pudo avanzar la etapa.',
    timeline: {
      title: 'Línea de tiempo',
      empty: 'Aún no hay comentarios ni eventos.',
      newCommentPlaceholder: 'Escriba un comentario…',
      addComment: 'Añadir comentario',
      commentAdded: 'Comentario añadido.',
      kanbanMoved: '{{actor}} movió la tarjeta en el tablero de preparación: {{from}} → {{to}}',
      operationalStage: '{{actor}} cambió la etapa operativa: {{from}} → {{to}}',
      preparationStage: '{{actor}} cambió la etapa de preparación: {{from}} → {{to}}',
      checklist: '{{actor}} — {{title}}: {{action}}',
      checklistActionCompleted: 'completado',
      checklistActionReopened: 'reabierto',
      checklistActionNotes: 'notas actualizadas',
      unknownEvent: 'Actividad registrada',
    },
    kanban: {
      boardTitle: 'Preparación',
      timeInColumn: 'Tiempo en la columna',
      moved: 'Tarjeta actualizada.',
      moveError: 'No se pudo mover la tarjeta.',
      moveOnlyAdjacent: 'Solo se permite mover a la columna anterior o siguiente inmediata.',
      cannotMoveBackFromLast: 'Después de llegar a la última columna, no se puede volver a etapas anteriores.',
      deliveryAtRequiredPrompt:
        'Ingrese la fecha y hora de entrega para entrar en la última columna (formato: AAAA-MM-DDTHH:mm).',
      deliveryAtInvalid: 'Fecha de entrega inválida.',
      columnResponsible: 'Responsable: {{name}}',
      columnResponsibleEmpty: 'Sin responsable',
      bayRequiresAssignee:
        'Para mover a la bahía, asigne todas las tareas de preparación a un usuario o defina el responsable de entrega en la venta.',
      noColumns: 'Configure el kanban para que esta etapa funcione.',
      nextPhase: 'Siguiente fase',
      responsible: 'Responsable',
      multipleAssignees: 'Varios responsables',
      swipeHint: 'Deslice horizontalmente para ver las columnas.',
      columns: {
        awaiting_preparation: 'En espera',
        in_preparation: 'En preparación',
        quality_control: 'Control de calidad',
        ready_for_delivery_handoff: 'Listo para entrega',
      },
    },
    delivery: {
      scheduledAt: 'Fecha de entrega',
      responsible: 'Responsable',
    },
    saleDetail: {
      checklistTitle: 'Checklist de la etapa actual',
      checklistEmpty: 'Sin ítems. Configure una plantilla.',
      configureCheckpoints: 'Configurar puntos de control de posventa',
      checklistSaved: 'Checklist actualizado.',
      checklistError: 'Error al actualizar checklist.',
      advance: 'Avanzar a la siguiente etapa',
      advanceOk: 'Etapa avanzada.',
      advanceError: 'No se pudo avanzar.',
      deliveryTitle: 'Datos de entrega',
      deliveryAt: 'Fecha y hora de entrega',
      deliverySaved: 'Entrega guardada.',
      deliveryError: 'Error al guardar entrega.',
    },
  },

  common: {
    name: 'Nombre',
    brand: 'Marca',
    model: 'Modelo',
    color: 'Color',
    mileage: 'Kilometraje',
    condition: 'Condición',
    fuel: 'Combustible',
    transmission: 'Transmisión',
    doors: 'Puertas',
    steering: 'Dirección',
    bodyBrand: 'Marca de carrocería',
    bodyModel: 'Modelo de carrocería',
    operation: 'Operación',
    fleetNumber: 'N.º de flota',
    salePrice: 'Precio de venta',
    purchasePrice: 'Precio de compra',
    photos: 'Fotos',
    video: 'Vídeo',
    km: 'km',
    warning: 'Atención',
    description: 'Descripción',
    status: 'Estado',
    date: 'Fecha',
    price: 'Precio',
    type: 'Tipo',
    category: 'Categoría',
    notes: 'Notas',
    active: 'Activo',
    inactive: 'Inactivo',
    yes: 'Sí',
    no: 'No',
    all: 'Todos',
    none: 'Ninguno',
    never: 'Nunca',
    optional: 'Opcional',
    required: 'Requerido',
    total: 'Total',
    notProvided: 'No informado',
    continueEditing: 'Continuar editando',
    loading: 'Cargando...',
    noResults: 'No se encontraron resultados',
    typeAtLeastChars: 'Ingrese al menos {{count}} caracteres',
    min: 'Mínimo',
    max: 'Máximo',
    days: {
      monday: 'Lun',
      tuesday: 'Mar',
      wednesday: 'Mié',
      thursday: 'Jue',
      friday: 'Vie',
      saturday: 'Sáb',
      sunday: 'Dom',
    },
    note: 'Nota',
  },

  vehicles: {
    title: 'Vehículos',
    subtitle: 'Gestiona el inventario de tu concesionario',
    new: 'Nuevo Vehículo',
    edit: 'Editar Vehículo',
    details: 'Detalles del Vehículo',
    list: 'Lista de Vehículos',
    brand: 'Marca',
    model: 'Modelo',
    version: 'Versión',
    year: 'Año',
    mileage: 'Kilometraje',
    color: 'Color',
    condition: 'Condición',
    fuelType: 'Tipo de Combustible',
    transmission: 'Transmisión',
    doors: 'Puertas',
    branch: 'Sucursal',
    selectBranch: 'Seleccione una sucursal',
    loadingBranches: 'Cargando sucursales...',
    registration: {
      selectVehicleTypeTitle: 'Seleccione el tipo de vehículo',
      vehicleCategoryLabel: 'Categoría del vehículo *',
      selectBranchFirst: 'Seleccione primero la sucursal para ver las categorías permitidas.',
      noBranchesHint: 'No hay sucursales disponibles. Registre una sucursal en Configuración del concesionario.',
      noCategoriesForBranch: 'Esta sucursal no tiene categorías habilitadas. Ajuste en Configuración del concesionario.',
      categoryLabels: {
        A: 'Moto',
        B: 'Automóvil',
        C: 'Camión',
        D: 'Autobús',
      },
    },
    validation: {
      branchRequired: 'Seleccione la sucursal del vehículo',
      categoryRequired: 'La categoría del vehículo es obligatoria',
      categoryNotAllowedForBranch: 'Esta categoría no está habilitada para la sucursal seleccionada',
    },
    salePrice: 'Precio de Venta',
    purchasePrice: 'Precio de Compra',
    contactActions: {
      contact: 'Entrar en contacto',
      duplicatePrompt: 'Este cliente ya está registrado. ¿Desea actualizar el registro existente?',
      duplicateRedirect: 'Redirigiendo para actualizar el registro existente.',
      duplicateCancelled: 'El lead no fue creado debido a duplicidad.',
    },
    filters: { title: 'Filtros', clear: 'Limpiar' },
    noVehicles: 'No se encontraron vehículos',
    photos: 'Fotos',
    features: 'Características',
    stats: {
      total: 'Total de Vehículos',
      inStock: 'En Stock',
      totalValue: 'Valor Total',
    },
    status: {
      inStock: 'En Stock',
      reserved: 'Reservado',
      sold: 'Vendido',
      inTransit: 'En Tránsito',
    },
    search: {
      placeholder: 'Buscar por nombre, placa o chassis...',
    },
    view: {
      grid: 'Cuadrícula',
      list: 'Lista',
    },
    results: {
      one: 'vehículo encontrado',
      multiple: 'vehículos encontrados',
      withFilters: ' con filtros activos',
    },
    table: {
      vehicle: 'Vehículo',
      year: 'Año',
      price: 'Precio',
      status: 'Estado',
      km: 'KM',
      actions: 'Acciones',
    },
    actions: {
      addVehicle: 'Agregar Vehículo',
      register: 'Registrar Vehículo',
      view: 'Ver',
      edit: 'Editar',
      delete: 'Eliminar',
    },
    success: {
      deleted: '¡Vehículo eliminado exitosamente!',
      published: '¡Vehículo publicado con éxito!',
    },
    empty: {
      noVehicles: 'No hay vehículos registrados',
      filters: 'No se encontraron vehículos',
      adjustFilters: 'Intenta ajustar los filtros para ver más resultados',
      addFirst: 'Agrega tu primer vehículo al inventario',
    },
    noIdentification: 'Sin identificación',
    priceLabel: 'Precio de venta',
    dialog: {
      deleteTitle: 'Confirmar Eliminación',
      deleteDescription: '¿Estás seguro de que deseas eliminar "{{name}}"? Esta acción no se puede deshacer.',
      thisVehicle: 'este vehículo',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
    },
    fields: {
      condition: 'Condición',
      category: 'Categoría',
    },
    category: 'Categoría',
    errors: {
      publish: 'No fue posible publicar el vehículo.',
    },
    marketplaces: 'Publicaciones en Marketplaces',
    publish: 'Publicar',
    published: 'Publicado',
    vehicleCondition: {
      new_vehicle: '0 KM',
      semi_new: 'Seminuevo',
      used: 'Usado',
    },
    vehicleStatus: {
      in_stock: 'En Stock',
      in_transit: 'En Tránsito',
      reserved: 'Reservado',
      sold: 'Vendido',
    },
  },


  vehicleRegistration: {
    basic: {
      title: 'Informações Básicas do Veículo',
      branchLabel: 'Filial',
      branchLoadingPlaceholder: 'Carregando filiais...',
      branchPlaceholder: 'Selecione uma filial (opcional)',
      noBranchesWarning: 'Nenhuma filial ativa disponível.',
      noBranchSelectedInfo: 'Selecione uma filial para continuar.',
      nameLabel: 'Nome do Veículo',
      nameHint: 'Será preenchido automaticamente ao selecionar marca, modelo e ano',
      namePlaceholder: 'Será preenchido automaticamente',
      generateName: 'Gerar Nome',
      generateNameTitle: 'Gerar nome automaticamente',
      brandLabel: 'Marca',
      brandPlaceholder: 'Buscar marca...',
      brandEmpty: 'Nenhuma marca encontrada',
      modelLabel: 'Modelo',
      modelPlaceholder: 'Buscar modelo...',
      modelSelectBrandFirst: 'Selecione uma marca primeiro',
      modelEmpty: 'Nenhum modelo encontrado',
      conditionLabel: 'Condição',
      conditionPlaceholder: 'Selecione a condição',
      modelYearLabel: 'Ano Modelo',
      modelYearPlaceholder: 'Selecione o ano modelo',
      manufactureYearLabel: 'Ano de Fabricação',
      manufactureYearPlaceholder: 'Selecione o ano de fabricação',
      manufactureYearHint: 'Ano de fabricação pode ser igual ao ano modelo ou 1 ano anterior',
      colorLabel: 'Cor',
      primaryColorLabel: 'Cor Primária',
      secondaryColorLabel: 'Cor Secundária',
      colorPlaceholder: 'Selecione',
      colorOptionalPlaceholder: 'Selecione (opcional)',
      mileageLabel: 'Quilometragem',
      mileagePlaceholder: '50.000',
      mileageZeroPlaceholder: '0 km',
      mileageHint: 'Quilometragem definida automaticamente para veículos 0 km',
      mileageRequiredHint: 'Quilometragem *',
      mileageAutoHint: 'Quilometragem definida automaticamente para veículos 0 km',
    },
    pricing: {
      title: 'Precios del vehículo',
      description: 'Ingresa los valores manualmente; ya no se usa la consulta FIPE en este flujo.',
      manualInfo: 'Los precios de venta, mínimo y compra se ingresan manualmente.',
      salePriceTitle: 'Precio de venta',
      requiredBadge: 'Obligatorio',
      minimumPriceTitle: 'Precio mínimo de venta',
      confidentialBadge: 'Confidencial',
      confidentialInfoTitle: 'Información confidencial',
      confidentialInfoMessage: 'El valor mínimo es privado y no se mostrará públicamente. Se utiliza solo en negociaciones e informes internos para control de margen.',
      minPriceWarning: 'El precio mínimo no puede ser mayor que el precio de venta.',
      purchasePriceTitle: 'Precio de compra',
      purchasePriceInfoMessage: 'Este valor es privado y no se mostrará públicamente. Se utiliza solo en informes internos para análisis de margen.',
      diffTitle: 'Diferencia',
      diffSubtitle: 'Venta − valor de compra',
      minDiffTitle: 'Dif. mín.',
      minDiffSubtitle: 'Mínimo − valor de compra',
      hidePricingLabel: 'Ocultar valores confidenciales a los vendedores',
      hidePricingDescription: 'Cuando se activa, el precio de compra y el precio mínimo se ocultan a los vendedores en propuestas y negociaciones. Solo administradores y gerentes pueden ver estos valores.',
      activeBadge: 'Activado',
      statusTitle: 'Estado del vehículo',
      statusDescription: 'Selecciona el estado actual del vehículo',
      statusLabel: 'Estado',
      statusPlaceholder: 'Selecciona un estado',
    },
    specifications: {
      carTitle: 'Especificações Técnicas',
      motorcycleTitle: 'Especificações Técnicas da Motocicleta',
      truckTitle: 'Especificações Técnicas do Caminhão',
      busTitle: 'Especificações Técnicas do Ônibus',
      fuelLabel: 'Combustível',
      transmissionLabel: 'Transmissão',
      automaticHint: 'Automático — padrão para veículos elétricos/híbridos',
      formHint: 'Informado no formulário',
      bodyTypeLabel: 'Tipo de Carroceria',
      bodyTypePlaceholder: 'Selecione o tipo de carroceria',
      bodyTypeShortPlaceholder: 'Selecione o tipo',
      doorsLabel: 'Número de Portas',
      doorsPlaceholder: '4',
      steeringLabel: 'Direção',
      steeringPlaceholder: 'Selecione a direção',
      motorcycleEngineLabel: 'Tipo de Motor',
      motorcycleCoolingLabel: 'Tipo de Refrigeração',
      motorcycleStarterLabel: 'Tipo de Partida',
      motorcycleFeedingLabel: 'Tipo de Alimentação',
      motorcycleFrontBrakeLabel: 'Freio Dianteiro',
      motorcycleRearBrakeLabel: 'Freio Traseiro',
      motorcycleGearsLabel: 'Número de Marchas',
      motorcycleGearsPlaceholder: '6',
      motorcycleCylinderLabel: 'Cilindrada (cc)',
      motorcycleCylinderPlaceholder: '150',
      motorcycleStyleLabel: 'Estilo',
      motorcycleCategoryLabel: 'Categoria',
      truckBodyTypeLabel: 'Tipo de Carroceria',
      truckBodyTypePlaceholder: 'Selecione a carroceria',
      truckCabTypeLabel: 'Tipo de Cabine',
      truckCabTypePlaceholder: 'Selecione a cabine',
      truckTractionLabel: 'Tração',
      truckTractionPlaceholder: 'Selecione a tração',
      truckAxlesLabel: 'Número de Eixos',
      truckAxlesPlaceholder: '3',
      truckGrossVehicleWeightLabel: 'PBT — Peso Bruto Total (kg)',
      truckGrossVehicleWeightPlaceholder: '23000',
      truckPayloadLabel: 'Capacidade de Carga (kg)',
      truckPayloadPlaceholder: '15000',
      truckTiresLabel: 'Quantidade de Pneus',
      truckTiresPlaceholder: '6',
      busBodyBrandLabel: 'Marca da Carroceria',
      busBodyBrandPlaceholder: 'Selecione',
      busBodyModelLabel: 'Modelo da Carroceria',
      busBodyModelPlaceholder: 'Ex: Paradiso, Torino, Apache...',
      busOperationTypeLabel: 'Tipo de Operação',
      busOperationTypePlaceholder: 'Selecione',
      busFleetNumberLabel: 'Número de Frota',
      busFleetNumberPlaceholder: 'Ex: 1042',
      busSeatedCapacityLabel: 'Capacidade Sentada',
      busSeatedCapacityPlaceholder: '44',
      busStandingCapacityLabel: 'Capacidade em Pé',
      busStandingCapacityPlaceholder: '20',
      busWheelchairCapacityLabel: 'Vagas para Cadeirante',
      busWheelchairCapacityPlaceholder: '2',
      featuresTitle: 'Itens e Opcionais do Veículo',
      busFeaturesTitle: 'Equipamentos do Ônibus',
      featuresDescription: 'Selecione os itens e características que o veículo possui (opcional)',
      featuresTipTitle: 'Dica:',
      featuresTipMessage: 'Selecione apenas as características que o veículo realmente possui. Isso ajuda os clientes a encontrar exatamente o que procuram.',
      comfortGroupTitle: 'Conforto',
      safetyGroupTitle: 'Segurança',
      technologyGroupTitle: 'Tecnologia',
      convenienceGroupTitle: 'Conveniência',
      performanceGroupTitle: 'Performance',
      lightingGroupTitle: 'Iluminação',
      adasGroupTitle: 'Sistemas Avançados (ADAS)',
      busEquipmentGroupTitle: 'Equipamentos',
      armorTitle: 'Blindagem e Categoria Especial',
      armorDescription: 'Configure se o veículo possui blindagem ou categoria especial',
      armorLabel: 'Nível de Blindagem',
      armorPlaceholder: 'Selecione o nível de blindagem',
      specialCategoryLabel: 'Categoria Especial',
      specialCategoryPlaceholder: 'Selecione a categoria especial',
      armorOptionalTitle: 'Opcional:',
      armorOptionalMessage: 'Configure apenas se o veículo possuir blindagem ou categoria especial (ex: táxi, ambulância, etc).',
      otherCharacteristicsTitle: 'Outras Características',
      otherCharacteristicsDescription: 'Características adicionais e diferenciais do veículo',
      otherCharacteristicsOptionalMessage: 'Selecione características adicionais que destacam o veículo (ex: único dono, revisões em dia, etc).',
      legalTitle: 'Situación Legal',
      legalDescription: 'Indique si existe algún gravamen o restricción financiera sobre el vehículo',
      alienatedLabel: 'Vehículo Alienado / Con Financiamiento',
      alienatedActiveDescription: 'Este vehículo tiene financiamiento activo. Informe el valor de la deuda en las propuestas de canje.',
      alienatedInactiveDescription: 'Indique si existe financiamiento, consorcio o alienación fiduciaria sobre este vehículo.',
      selectPlaceholder: 'Seleccione',
      fuelSelectPlaceholder: 'Seleccione el combustible',
      transmissionSelectPlaceholder: 'Seleccione la transmisión',
    },
    documentation: {
      title: 'Documentación do Veículo',
      plateLabel: 'Placa',
      chassisLabel: 'Chassi',
      chassisPlaceholder: '9BWZZZ377VT004251',
      renavamLabel: 'RENAVAM',
      renavamPlaceholder: '00000000000',
      documentsLabel: 'Documentos do Veículo',
      addDocumentsLabel: 'Adicionar Novos Documentos',
      documentsHint: 'Envie documentos como CRLV, nota fiscal, etc. Selecione a categoria de cada documento. Formatos aceitos: PDF, JPG, PNG',
      inspectedLabel: 'Veículo Vistoriado',
      inspectedDescription: 'Marque se o veículo passou por vistoria técnica',
      inspectedBadge: 'Vistoriado',
      inspectionDateLabel: 'Data da Vistoria',
      inspectionDatePlaceholder: 'Selecione a data da vistoria',
      inspectionTitle: 'Inspección y Reconocimiento',
      auctionTitle: 'Informações de Leilão',
      auctionLabel: 'Veículo de Leilão',
      auctionDescription: 'Marque se este veículo veio de leilão',
      auctionBadge: 'Leilão',
      auctionCategoryLabel: 'Categoria do Leilão',
      auctionCategoryPlaceholder: 'Selecione a categoria',
      auctionSubtypeLabel: 'Subtipo',
      auctionSubtypePlaceholder: 'Selecione o subtipo',
      damageLevelLabel: 'Nível de Danos',
      damageLevelPlaceholder: 'Selecione o nível de danos',
      importanceTitle: 'Importante:',
      importanceMessage: 'Informações de leilão são relevantes para transparência com o cliente. Sempre informe se o veículo veio de leilão e o nível de danos, se houver.',
      descriptionTitle: 'Descrição do Veículo',
      descriptionLabel: 'Descrição',
      descriptionPlaceholder: 'Ex: Veículo em excelente estado de conservação, único dono, todas as revisões em dia, manual e chave reserva...',
      descriptionSubtitle: 'Descreva o veículo de forma atrativa e detalhada',
      descriptionHint: 'Mínimo 10 caracteres. Destaque os principais diferenciais.',
      tipTitle: 'Dica:',
      tipMessage: 'Uma boa descrição aumenta as chances de venda. Mencione:',
      tip1: 'Estado de conservação do veículo',
      tip2: 'Histórico de manutenção e revisões',
      tip3: 'Principais diferenciais e opcionais',
      tip4: 'Documentação regularizada',
      tip5: 'Aceita troca ou financiamento (se aplicável)',
      descriptionHintEdit: 'Destaque los diferenciales principales y el estado de conservación',
      auctionDamageLabel: 'Nivel de Daños',
      auctionDamagePlaceholder: 'Seleccione el nivel de daños',
      auctionImportantMessage: 'La información de subasta es relevante para la transparencia con el cliente. Informe siempre si el vehículo proviene de una subasta y su nivel de daños, si corresponde.',
      auctionImportantTitle: 'Importante:',
      descriptionDescription: 'Describa el vehículo de forma atractiva y detallada',
      descriptionTipConservation: 'Estado de conservación del vehículo',
      descriptionTipDifferentials: 'Principales diferenciales y opcionales',
      descriptionTipDocumentation: 'Documentación regularizada',
      descriptionTipMaintenance: 'Historial de mantenimiento y revisiones',
      descriptionTipMessage: 'Una buena descripción aumenta las posibilidades de venta. Mencione:',
      descriptionTipTitle: 'Consejo:',
      descriptionTipTradeOrFinance: 'Acepta permuta o financiamiento (si corresponde)',
    },
    summary: {
      title: 'Resumo Final — Revise as Informações',
      description: 'Revise todas as informações antes de finalizar o cadastro',
      readyTitle: '¡Listo para guardar!',
      readyMessage: 'Revise toda la información a continuación antes de completar el registro.',
      basicSectionTitle: 'Información básica',
      valuesSectionTitle: 'Valores',
      technicalSectionTitle: 'Especificaciones técnicas',
      documentationSectionTitle: 'Documentación',
      descriptionSectionTitle: 'Descripción',
      mediaSectionTitle: 'Multimedia',
      nameLabel: 'Nombre',
      brandLabel: 'Marca',
      modelLabel: 'Modelo',
      conditionLabel: 'Condición',
      modelYearAndManufactureYearLabel: 'Año modelo / Año de fabricación',
      colorLabel: 'Color',
      mileageLabel: 'Kilometraje',
      salePriceLabel: 'Precio de venta',
      minimumPriceLabel: 'Precio mínimo',
      purchasePriceLabel: 'Precio de compra',
      statusLabel: 'Estado',
      fuelLabel: 'Combustible',
      transmissionLabel: 'Transmisión',
      typeLabel: 'Tipo',
      doorsLabel: 'Puertas',
      steeringLabel: 'Dirección',
      busBodyBrandLabel: 'Marca de carrocería',
      busBodyModelLabel: 'Modelo de carrocería',
      busOperationTypeLabel: 'Operación',
      busFleetNumberLabel: 'N.º de flota',
      plateLabel: 'Patente',
      chassisLabel: 'Chasis',
      renavamLabel: 'RENAVAM',
      inspectionLabel: 'Inspección',
      inspectionValuePrefix: 'Inspeccionado el',
      inspectionDateMissing: 'Fecha no informada',
      auctionLabel: 'Subasta',
      auctionValue: 'Vehículo de subasta',
      descriptionLabel: 'Descripción del vehículo',
      photosLabel: 'Fotos',
      photoSelectedOne: '1 foto seleccionada',
      photoSelectedMany: '{{count}} fotos seleccionadas',
      videoLabel: 'Vídeo',
      warningTitle: 'Atención:',
      warningMessage: 'Revise toda la información antes de finalizar. Podrá editarla más adelante si es necesario.',
    },
  },

  leads: {
    title: 'Leads',
    new: 'Nuevo Lead',
    edit: 'Editar Lead',
    details: 'Detalles del Lead',
    clientInfo: 'Información del Cliente',
    vehicleInterests: 'Vehículos de Interés',
    preferences: 'Preferencias del Cliente',
    source: 'Origen',
    seller: 'Vendedor',
    autoTransfer: {
      title: 'Transferencia Automática',
      description: 'Configura reglas para transferir leads automáticamente',
      defaultSeller: 'Vendedor predeterminado (respaldo)',
      defaultSellerHint:
        'Cuando ninguna regla coincida con el lead, la asignación usará este vendedor. Opcional.',
      defaultSellerNone: 'Sin vendedor predeterminado',
      defaultSellerSaved: 'Vendedor predeterminado actualizado.',
      defaultSellerError: 'No se pudo guardar el vendedor predeterminado.',
      returnRuleTitle: 'Regla de retorno (obligatoria)',
      returnRuleHint:
        'Esta regla tiene prioridad sobre todas las demás. Define cuándo un lead puede volver al vendedor anterior.',
      alwaysReturn: 'Siempre retornar al vendedor anterior',
      unitHours: 'Horas',
      unitDays: 'Días',
      unitMonths: 'Meses',
      returnRuleSaved: 'Regla de retorno actualizada.',
      returnRuleError: 'No se pudo guardar la regla de retorno.',
      returnRuleInvalid: 'Ingresa un valor entero mayor que cero.',
      tabRules: 'Reglas',
      tabHistory: 'Historial',
      historyTitle: 'Historial de cambios',
      historyEmpty: 'Aún no hay cambios registrados.',
      historyLoadError: 'No se pudo cargar el historial.',
      historyOldValues: 'Antes',
      historyNewValues: 'Después',
      historyActionToggle: 'Activación de transferencia automática',
      historyActionDefaultSeller: 'Vendedor predeterminado',
      historyActionReturnRule: 'Regla de retorno',
      historyActionRuleCreated: 'Regla creada',
      historyActionRuleUpdated: 'Regla actualizada',
      historyActionRuleDeleted: 'Regla eliminada',
      historyActionRulesReordered: 'Reordenación de reglas',
      enabled: 'Activado',
      addRule: 'Nueva Regla',
      addFirstRule: 'Agregar primera regla',
      noRules: 'No hay reglas configuradas',
      conditions: 'condiciones',
      inactive: 'Inactivo',
      ruleName: 'Nombre de la Regla',
      ruleNamePlaceholder: 'Ej: Clientes de São Paulo',
      assignedUsers: 'Vendedores',
      selectUsers: 'Selecciona vendedores',
      branch: 'Sucursal',
      selectBranch: 'Selecciona sucursal',
      allBranches: 'Todas las sucursales',
      branchDesc: 'Las reglas se aplican solo a la sucursal seleccionada',
      branches: 'Sucursales',
      selectBranches: 'Selecciona sucursales',
      branchesDesc: 'Selecciona una o más sucursales. Déjalo vacío para aplicar a todas.',
      searchUsers: 'Buscar vendedores',
      editRule: 'Editar Regla',
      newRule: 'Nueva Regla',
      confirmDelete: '¿Estás seguro de que quieres eliminar esta regla?',
      // Tipo de regla
      ruleType: 'Tipo de Regla',
      byCharacteristics: 'Por Características',
      bySpecificVehicles: 'Por Vehículos Específicos',
      byCharacteristicsDesc: 'Distribuye leads basado en características como marca, modelo, precio, ubicación, etc.',
      bySpecificVehiclesDesc: 'Distribuye leads basado en vehículos específicos de tu inventario.',
      selectVehicles: 'Selecciona vehículos',
      searchVehicles: 'Buscar vehículos',
      removeVehicle: 'Eliminar vehículo',
      // Secciones del formulario
      geographicFilters: 'Filtros Geográficos',
      geographicFiltersDesc: 'Define regiones, ciudades y barrios',
      vehicleFilters: 'Filtros de Vehículo',
      vehicleFiltersDesc: 'Especifica características del vehículo',
      priceAndRange: 'Rangos de Precio y Año',
      priceAndRangeDesc: 'Define límites de precio, año y kilometraje',
      schedule: 'Horario de Atención',
      scheduleDesc: 'Define días y horarios para distribución',
      leadSources: 'Fuentes de Lead',
      leadSourcesDesc: 'Selecciona de qué fuentes se distribuirán los leads',
      // Campos geográficos
      regions: 'Regiones',
      regionsPlaceholder: 'Selecciona las regiones',
      regionNorth: 'Norte',
      regionNortheast: 'Noreste',
      regionMidwest: 'Centro-Oeste',
      regionSoutheast: 'Sudeste',
      regionSouth: 'Sur',
      states: 'Estados',
      selectStates: 'Selecciona los estados',
      searchStates: 'Buscar estados',
      cities: 'Ciudades',
      selectCities: 'Selecciona las ciudades',
      searchCities: 'Buscar ciudades',
      selectStatesFirst: 'Selecciona estados primero',
      citiesPlaceholder: 'Selecciona las ciudades',
      neighborhoods: 'Barrios',
      neighborhoodsPlaceholder: 'Ingresa los barrios',
      searchNeighborhoods: 'Buscar barrios',
      zipCodes: 'Códigos Postales',
      zipCodesPlaceholder: 'Ingresa los códigos',
      // Campos de vehículo
      categories: 'Categorías',
      categoriesPlaceholder: 'Selecciona las categorías',
      vehicleTypes: 'Tipos de Vehículo',
      vehicleTypesPlaceholder: 'Selecciona los tipos',
      vehicleConditions: 'Condición',
      vehicleConditionsPlaceholder: 'Nuevo, Usado, Seminuevo',
      brands: 'Marcas',
      brandsPlaceholder: 'Selecciona las marcas',
      selectCategoriesFirst: 'Selecciona categorías primero',
      models: 'Modelos',
      modelsPlaceholder: 'Selecciona los modelos',
      selectBrandsFirst: 'Selecciona marcas primero',
      versions: 'Versiones',
      versionsPlaceholder: 'Selecciona las versiones',
      fuelTypes: 'Combustible',
      fuelTypesPlaceholder: 'Selecciona los tipos',
      transmissions: 'Transmisión',
      transmissionsPlaceholder: 'Selecciona los tipos',
      colors: 'Colores',
      colorsPlaceholder: 'Selecciona los colores',
      armorLevels: 'Niveles de Blindaje',
      armorLevelsPlaceholder: 'Selecciona los niveles',
      // Rangos
      yearRange: 'Año del Vehículo',
      minYear: 'Año Mínimo',
      maxYear: 'Año Máximo',
      priceRange: 'Rango de Precio',
      minPrice: 'Precio Mínimo',
      maxPrice: 'Precio Máximo',
      mileageRange: 'Kilometraje',
      minMileage: 'KM Mínimo',
      maxMileage: 'KM Máximo',
      // Horario
      scheduleDays: 'Días de la Semana',
      scheduleStart: 'Hora de Inicio',
      scheduleEnd: 'Hora de Fin',
      // Fuentes
      sources: 'Fuentes',
      sourcesPlaceholder: 'Selecciona las fuentes',
      leadSourceKeys: 'Claves de Origen',
      leadSourceKeysPlaceholder: 'Ingresa las claves',
      // Opciones comunes
      new: 'Nuevo',
      used: 'Usado',
      // Mensajes de feedback
      ruleNameRequired: 'El nombre de la regla es obligatorio',
      selectUsersRequired: 'Selecciona al menos un vendedor',
      ruleCreatedSuccess: '¡Regla creada con éxito!',
      ruleUpdatedSuccess: '¡Regla actualizada con éxito!',
      ruleSaveError: 'Error al guardar la regla. Inténtalo de nuevo.',
      reorderSuccess: '¡Orden de reglas actualizado con éxito!',
      reorderError: 'Error al reordenar reglas. Inténtalo de nuevo.',
      deleteRuleTitle: '¿Eliminar regla?',
      deleteRuleDescription: '¿Estás seguro de que deseas eliminar la regla "{{name}}"? Esta acción no se puede deshacer.',
      deleteRuleDescriptionGeneric: '¿Estás seguro de que deseas eliminar esta regla? Esta acción no se puede deshacer.',
      ruleDeletedSuccess: '¡Regla eliminada con éxito!',
      deleteError: 'Error al eliminar la regla. Inténtalo de nuevo.',
      certified: 'Seminuevo Certificado',
      car: 'Coche',
      motorcycle: 'Moto',
      truck: 'Camión',
      gasoline: 'Gasolina',
      diesel: 'Diesel',
      electric: 'Eléctrico',
      flex: 'Flex',
      hybrid: 'Híbrido',
      manual: 'Manual',
      automatic: 'Automático',
      cvt: 'CVT',
      automatedManual: 'Automatizada',
    },
    form: {
      vehicle: 'Vehículo',
      searchVehicle: 'Buscar vehículo por nombre, marca o modelo...',
      personTypePF: 'Persona Física',
      personTypePJ: 'Persona Jurídica',
      documentCpfPlaceholder: '000.000.000-00',
      documentCnpjPlaceholder: '00.000.000/0000-00',
      documentCpfHint: 'Ingrese 11 dígitos para CPF',
      documentCnpjHint: 'Ingrese 14 dígitos para CNPJ',
      documentCpfValid: 'CPF válido',
      documentCnpjValid: 'CNPJ válido',
      documentCpfTitle: 'CPF - Registro de Pessoa Física',
      documentCnpjTitle: 'CNPJ - Registro Nacional de Personas Jurídicas',
      documentTypeHint: 'Elige el tipo de documento antes de ingresar el número.',
      duplicateFoundTitle: 'Cliente ya registrado',
      duplicateFoundMessage: 'Ya existe un registro para este cliente.',
      goToEdit: 'Ir a Editar',
      checkingPhone: 'Verificando teléfono...',
      checkingDocument: 'Verificando documento...',
      documentDuplicateCPF: 'Este CPF ya está registrado para el cliente: {{name}}',
      documentDuplicateCNPJ: 'Este CNPJ ya está registrado para el cliente: {{name}}',
      // Campos del formulario
      fullName: 'Nombre Completo',
      fullNamePlaceholder: 'Ingrese nombre completo',
      documentLabel: 'Documento',
      cnhLabel: 'Licencia de Conducir',
      phonesLabel: 'Teléfonos',
      emailsLabel: 'Correos Electrónicos',
      initialMessageLabel: 'Mensaje Inicial',
      messageLabel: 'Mensaje',
      messagePlaceholder: 'Ingrese el mensaje inicial del cliente...',
      personalInfoTitle: 'Información Personal',
      personalInfoDescription: 'Identificación y datos principales del lead.',
      contactsTitle: 'Contactos',
      contactsDescription: 'Teléfono y correo para dar seguimiento al lead.',
      vehicleInterestTitle: 'Búsqueda de Vehículo',
      vehicleInterestDescription: 'Intereses del lead para orientar la atención.',
      messageDescription: 'Contexto inicial compartido por el cliente.',
      exit: 'Salir',
      openExisting: 'Abrir Cliente',
    },
    filters: {
      title: 'Filtros',
      search: 'Buscar',
      searchPlaceholder: 'Nombre, teléfono, correo...',
      name: 'Nombre',
      namePlaceholder: 'Filtrar por nombre',
      phone: 'Teléfono',
      phonePlaceholder: 'Filtrar por teléfono',
      email: 'Correo',
      emailPlaceholder: 'Filtrar por correo',
      document: 'Documento',
      documentPlaceholder: 'CPF/CNPJ',
      status: 'Estado',
      source: 'Origen',
      serviceUser: 'Usuario de atención',
      serviceUserPlaceholder: 'Seleccionar usuario',
      vehicleInterest: 'Vehículo de interés',
      vehicleInterestPlaceholder: 'Buscar vehículo...',
      hasProposal: 'Tiene propuesta',
      hasPreferences: 'Tiene preferencias',
      funnelStage: 'Etapa del embudo',
      converted: 'Convertido',
      createdAtFrom: 'Fecha creación (desde)',
      createdAtTo: 'Fecha creación (hasta)',
      all: 'Todos',
      yes: 'Sí',
      no: 'No',
      clearFilters: 'Limpiar filtros',
      applyFilters: 'Aplicar',
      clear: 'Limpiar',
      customerData: 'Datos del Cliente',
      createdAt: 'Fecha de Creación',
      proposalConversion: 'Propuesta y Conversión',
    },
    status: {
      new: 'Nuevo',
      contacted: 'Contactado',
      qualified: 'Calificado',
      proposal: 'Propuesta',
      negotiating: 'Negociando',
      negotiation: 'Negociando',
      converted: 'Convertido',
      won: 'Ganado',
      lost: 'Perdido',
    },
    kanban: {
      funnelNotConfiguredTitle: 'Embudo de ventas no configurado',
      funnelNotConfiguredDescription:
        'Para ver los leads en modo Kanban, configura un embudo de ventas. Accede a la configuración de leads para crear tu embudo.',
      configureFunnelLink: 'Configurar embudo de ventas',
      advanceRequiresAssignee:
        'Asigna un vendedor al lead antes de avanzar a la siguiente etapa.',
      moveToPreviousStage: 'Mover a la etapa anterior',
      moveToNextStage: 'Mover a la siguiente etapa',
      nextStageRequiresAssignee: 'Asigna un vendedor al lead para avanzar',
      stageUpdated: 'Etapa actualizada.',
      stageUpdateFailed: 'No fue posible actualizar la etapa.',
    },
    drawer: {
      openWhatsAppConversations: 'Ir a conversaciones de WhatsApp',
      assignSalesperson: 'Vendedor asignado',
      assignSalespersonPlaceholder: 'Buscar vendedor…',
      saveAssignee: 'Guardar vendedor',
      assigneeUpdated: 'Vendedor actualizado.',
      assigneeUpdateFailed: 'No fue posible actualizar el vendedor.',
      savingAssignee: 'Guardando…',
    },
    report: {
      title: 'Informe de leads',
      subtitle:
        'Vista tabular con los mismos filtros que el listado. Exporta CSV con todos los campos guardados.',
      exportCsv: 'Exportar CSV',
      exporting: 'Generando archivo…',
      exportSuccess: 'Descarga iniciada.',
      exportError: 'No fue posible exportar el informe.',
      exportHint: 'El CSV incluye dirección, preferencias, financiamiento, vehículos de interés y más.',
      showingCount: 'Mostrando {{count}} de {{total}} leads (vista previa hasta 500 filas).',
      column: {
        name: 'Nombre',
        document: 'Documento',
        status: 'Estado',
        source: 'Origen',
        phone: 'Teléfono',
        email: 'Correo',
        assigned: 'Responsable',
        stage: 'Etapa',
        createdAt: 'Creado',
      },
      filters: {
        dateFrom: 'Fecha desde',
        dateTo: 'Fecha hasta',
        media: 'Medio',
        allMedia: 'Todos los medios',
        stage: 'Etapa',
        allStages: 'Todas las etapas',
        status: 'Estado',
        allStatuses: 'Todos los estados',
        phone: 'Teléfono',
        phonePlaceholder: 'Ingrese teléfono',
        email: 'Correo',
        emailPlaceholder: 'Ingrese correo',
        clear: 'Limpiar filtros',
      },
    },
    contactActions: {
      contact: 'Ponerse en contacto',
      duplicateCancelled: 'Registro no creado debido a duplicidad.',
      duplicateFoundMessage: 'Ya existe un registro para este cliente.',
      duplicateFoundTitle: 'Cliente ya registrado',
      duplicatePrompt: 'Ya existe un registro para este cliente, ¿desea actualizar los datos?',
      duplicateRedirect: 'Redirigiendo para actualizar el registro existente.',
      exit: 'Salir',
      openClient: 'Abrir Cliente',
    },
},

  leadsSettingsHub: {
    title: 'Configuraciones de Leads',
    subtitle: 'Centraliza configuraciones de entrada, embudo y distribución de leads.',
    comingSoon: 'Próximamente',
    cards: {
      kanban: {
        title: 'Kanban',
        description: 'Configura etapas y reglas del embudo de leads.',
      },
      omnichannel: {
        title: 'Omnichannel',
        description: 'Atención unificada y consolidación de canales.',
      },
      integrations: {
        title: 'Integraciones',
        description: 'Conecta canales y plataformas de captación de leads.',
      },
      webhooks: {
        title: 'Webhooks',
        description: 'Configura endpoints y payloads para entrada de leads.',
      },
      distribution: {
        description: 'Gestione las reglas de distribución automática de leads.',
        title: 'Distribución',
      },
      whatsapp: {
        description: 'Configure la integración con la API de WhatsApp Business.',
        title: 'WhatsApp',
      },
    },
    integrations: {
      title: 'Integraciones de Leads',
      subtitle: 'Configura integraciones con canales de adquisición de leads.',
      placeholder: 'Esta área se habilitará en una próxima entrega.',
    },
    webhooks: {
      title: 'Webhooks de Leads',
      subtitle: 'Configura webhooks y usa el endpoint público para recibir leads.',
      publicEndpointTitle: 'Endpoint público para entrada de leads',
      payloadExampleTitle: 'Ver ejemplo de payload JSON',
      curlExampleTitle: 'Ver ejemplo de cURL',
      payloadHint: 'Payload esperado: name, phones [{ ddi, ddd, phone }], opcionalmente email, message y vehicleReference.',
      newTitle: 'Nuevo webhook',
      editTitle: 'Editar webhook',
      listTitle: 'Webhooks configurados',
      create: 'Crear webhook',
      saveEdit: 'Guardar cambios',
      empty: 'No hay webhooks configurados.',
      saved: 'Webhook guardado con éxito.',
      removed: 'Webhook eliminado con éxito.',
      fields: {
        name: 'Nombre',
        media: 'Medio',
        mediaPlaceholder: 'Seleccionar...',
        active: 'Activo',
      },
      errors: {
        required: 'Complete nombre y medio.',
        save: 'No se pudo guardar el webhook.',
        delete: 'No se pudo eliminar el webhook.',
      },
    },
  },

  leadMediaSettings: {
    title: 'Catálogo de Medios de Leads',
    subtitle: 'Registre medios personalizados y consulte el catálogo global servido por la API.',
    createTitle: 'Nuevo medio de la concesionaria',
    sections: {
      catalogGlobal: 'Catálogo global',
      custom: 'Medios de la concesionaria',
    },
    tier: {
      spotlight: 'Destacado',
      standard: 'Estándar',
    },
    fields: {
      key: 'Clave técnica',
      label: 'Nombre visible',
      color: 'Color (hex)',
      sortOrder: 'Orden',
      active: 'Activa',
    },
    actions: {
      create: 'Crear medio',
      clear: 'Limpiar',
    },
    success: {
      saved: 'Medio guardado con éxito.',
      deleted: 'Medio eliminado con éxito.',
    },
    errors: {
      load: 'No se pudieron cargar los medios.',
      required: 'Complete clave y nombre del medio.',
      save: 'No se pudo guardar el medio.',
      delete: 'No se pudo eliminar el medio. Verifique si está en uso.',
    },
    emptyCatalog: 'No hay entradas en el catálogo global.',
    emptyCustom: 'No hay medios personalizados registrados.',
    readOnly: 'Solo lectura',
    active: 'activa',
    inactive: 'inactiva',
    meta: 'clave: {{key}} | orden: {{order}} | {{status}}',
    metaCatalog: 'clave: {{key}} | orden: {{order}} | {{tier}}',
  },

  leadWorkingMedia: {
    title: 'Medios con los que trabaja la concesionaria',
    subtitle: 'Seleccione del catálogo global los medios que la concesionaria utiliza en la operación.',
    catalogTitle: 'Catálogo de medios',
    empty: 'No hay medios disponibles.',
    active: 'Activa',
    inactive: 'Inactiva',
    rowAria: '{{label}}. Estado: {{state}}. Pulse para alternar.',
    meta: 'clave: {{key}} | {{tier}}',
    tier: {
      spotlight: 'Destacado',
      standard: 'Estándar',
    },
    success: {
      updated: 'Selección actualizada con éxito.',
    },
    errors: {
      load: 'No se pudieron cargar los medios.',
      update: 'No se pudo actualizar la selección.',
      keepNotInformed: 'La opción "No informada" debe permanecer seleccionada.',
    },
  },

  proposals: {
    title: 'Propuestas',
    new: 'Nueva Propuesta',
    edit: 'Editar Propuesta',
    details: 'Detalles de la Propuesta',
    form: {
      financialProposalTitle: 'Propuesta financiera',
      invalidNegotiatedPrice: 'Valor no válido.',
      advertisedPrice: 'Precio anunciado',
      negotiatedVehicleValue: 'Valor del vehículo negociado',
      applyVehicleAdvertisedPrice: 'Valor del vehículo',
      selectVehicleForPrices:
        'Seleccione un vehículo en el paso anterior para ver el precio anunciado.',
      referenceSectionTitle: 'Referencia de precio',
      negotiationSectionTitle: 'Negociación',
      financialIntro:
        'Defina precios, beneficios y cargos que componen el valor para el cliente.',
      paymentsMustBePositive: 'Todos los pagos deben tener un valor mayor que R$ 0,00.',
      paymentsMustCoverFinalPrice:
        'El total de los pagos debe cubrir el valor final de la propuesta. Ajuste los importes antes de continuar o guardar.',
      searchVehicle: 'Buscar vehículo por nombre, marca o modelo...',
      vehicle: 'Vehículo',
    },
    actions: {
      acceptProposal: 'Aceptar propuesta',
      rejectProposal: 'Rechazar propuesta',
      dialogAcceptTitle: 'Aceptar propuesta',
      dialogRejectTitle: 'Rechazar propuesta',
      dialogAcceptBody:
        '¿Seguro que desea aceptar esta propuesta? Se creará una venta y el vehículo quedará marcado como vendido.',
      dialogRejectBody:
        '¿Seguro que desea rechazar esta propuesta? Esta acción no se puede deshacer.',
      confirmAccept: 'Sí, aceptar',
      confirmReject: 'Sí, rechazar',
      toastAccepted: '¡Propuesta aceptada con éxito!',
      toastRejected: '¡Propuesta rechazada con éxito!',
      toastAcceptError: 'Error al aceptar la propuesta. Inténtelo de nuevo.',
      toastRejectError: 'Error al rechazar la propuesta. Inténtelo de nuevo.',
    },
  },

  customers: {
    edit: {
      title: 'Editar cliente',
      sectionContact: 'Contacto',
      sectionAddress: 'Dirección',
      sectionNotes: 'Notas',
      name: 'Nombre',
      documentCpf: 'CPF',
      documentCnpj: 'CNPJ',
      documentReadOnlyHint: 'El documento no se puede cambiar.',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      notes: 'Notas',
      save: 'Guardar',
      loadError: 'No se pudo cargar el cliente.',
      saveError: 'No se pudo guardar.',
      saveSuccess: 'Cliente actualizado.',
      sectionFunnelOrigin: 'Historial del embudo (lead de origen)',
      originLeadName: 'Nombre en el lead',
      originLeadSource: 'Origen',
      originLeadStatus: 'Etapa',
      originLeadCreatedAt: 'Creado el',
      originLeadConvertedAt: 'Convertido el',
      originLeadMessage: 'Mensaje inicial',
      originLeadNotes: 'Notas del embudo',
      openOriginLead: 'Abrir lead',
    },
    address: {
      zipCode: 'CEP',
      lookupZip: 'Buscar CEP',
      zipInvalid: 'Ingrese un código postal de 8 dígitos.',
      street: 'Calle',
      number: 'Número',
      complement: 'Complemento',
      neighborhood: 'Barrio',
      city: 'Ciudad',
      state: 'UF',
      searchingZip: 'Buscando CEP...',
      zipLookupError: 'No se pudo buscar el CEP.',
    },
  },

  financial: {
    title: 'Financiero',
    commissionRules: 'Reglas de Comisión',
    newRule: 'Nueva Regla',
    editRule: 'Editar Regla',
    basicConfig: 'Configuración Básica',
    advancedRules: 'Reglas Avanzadas',
    validity: 'Vigencia',
    commissionType: 'Tipo de Comisión',
    percentage: 'Porcentaje',
    fixed: 'Valor Fijo',
    mixed: 'Mixto',
    applicableTo: 'Aplicable a',
    salesperson: 'Vendedor',
    manager: 'Gerente',
    dealership: 'Concesionario',
    isMandatoryCommission: 'Comisión obligatoria en la venta',
    isMandatoryCommissionHint:
      'Si está activa, la regla se aplica automáticamente en la venta y los importes no se pueden cambiar.',
    mandatoryRuleBadge: 'Obligatoria',
  },

  settings: {
    title: 'Configuración',
    theme: 'Tema',
    language: 'Idioma',
    notifications: 'Notificaciones',
    operationPipeline: {
      cardTitle: 'Esteira operacional',
      cardDescription: 'Columnas del kanban y plantillas de checklist por etapa.',
      pageTitle: 'Esteira operacional',
      pageSubtitle: 'Defina columnas del kanban (preparación y post-entrega) y plantillas de checklist.',
      tabKanban: 'Kanban',
      tabChecklists: 'Checklists',
      kanbanTitle: 'Columnas del tablero',
      boardStage: 'Etapa del tablero',
      active: 'Activa',
      handoff: 'Columna de liberación',
      columnResponsible: 'Responsable de la columna',
      columnResponsibleEmpty: 'Sin responsable',
      newColumnTitle: 'Nueva columna',
      newColumnPlaceholder: 'Ej.: Lavado',
      addColumn: 'Añadir columna',
      kanbanLoadError: 'No se pudieron cargar las columnas.',
      columnCreated: 'Columna creada.',
      columnSaveError: 'No se pudo guardar la columna.',
      columnDeleted: 'Columna eliminada.',
      columnDeleteError: 'No se pudo eliminar la columna.',
      reorderOk: 'Orden actualizado.',
      reorderError: 'No se pudo reordenar.',
      confirmDeleteColumn: '¿Eliminar columna?',
      confirmDeleteColumnHint:
        'Todos los vehículos en esta columna pasarán a la columna anterior. Los ítems de checklist vinculados a esta columna se eliminarán. Esta acción no se puede deshacer.',
      edgeColumnBadge: 'Fija',
      edgeColumnHelp: 'La primera y la última columna del tablero no se pueden editar ni eliminar.',
      columnChecklistTitle: 'Checklist de esta columna',
      columnChecklistHelp:
        'Ítems mostrados como checklist cuando la venta está en esta columna. Coincide con la plantilla vinculada a la columna.',
      columnChecklistLines: 'Ítems',
      columnChecklistPlaceholder: 'Ej.: Lavado exterior\nLista de accesorios',
      checklistItemPlaceholder: 'Texto del ítem',
      addChecklistItem: 'Añadir ítem',
      removeChecklistItem: 'Quitar ítem',
      templateItemsEmpty: 'Ningún ítem en esta plantilla.',
      saveColumnChecklist: 'Guardar checklist de la columna',
      columnChecklistSaved: 'Checklist de la columna guardado.',
      columnChecklistError: 'No se pudo guardar el checklist de la columna.',
      checklistsTitle: 'Plantillas de checklist',
      filterStage: 'Filtrar por etapa',
      allStages: 'Todas las etapas',
      items: 'ítems',
      noTemplates: 'Ninguna plantilla registrada.',
      newTemplate: 'Nueva plantilla',
      templateStage: 'Etapa operacional',
      itemsLines: 'Ítems (uno por línea)',
      itemsPlaceholder: 'Documentación\nInspección final\nCapacitación al cliente',
      createTemplate: 'Crear plantilla',
      templateFormInvalid: 'Indique el nombre y al menos un ítem.',
      templateCreated: 'Plantilla creada.',
      templateSaveError: 'No se pudo guardar la plantilla.',
      templateDeleted: 'Plantilla eliminada.',
      templateDeleteError: 'No se pudo eliminar la plantilla.',
      checklistLoadError: 'No se pudieron cargar las plantillas.',
      confirmDeleteTemplate: '¿Eliminar plantilla?',
      confirmDeleteTemplateHint: 'Las ventas nuevas dejarán de recibir esta plantilla automáticamente. Los ítems ya creados en ventas no se eliminan.',
      tabSaleOnboarding: 'Pre-flujo venta',
      saleOnboardingIntro:
        'Defina documentos exigidos y plantillas de contrato antes de enviar la venta desde finanzas a preparación operativa.',
      onboardingLoadError: 'No se pudo cargar la configuración del pre-flujo.',
      onboardingDocTypesTitle: 'Tipos de documento',
      onboardingContractTemplatesTitle: 'Plantillas de contrato',
      onboardingSlug: 'Slug',
      onboardingAttach: 'Dónde se adjunta el archivo',
      onboardingAttachSale: 'En la venta',
      onboardingAttachCustomer: 'En la ficha del cliente',
      onboardingSort: 'Orden de visualización',
      onboardingRequired: 'Obligatorio',
      onboardingDocTypesEmpty:
        'Sin tipos. Sin tipos obligatorios activos, la etapa de documentación se considera completa.',
      onboardingContractsEmpty: 'Sin plantillas.',
      onboardingNewDocType: 'Nuevo tipo de documento',
      onboardingAddDocType: 'Añadir tipo',
      onboardingDocTypeInvalid: 'Indique nombre y slug.',
      onboardingDocTypeCreated: 'Tipo creado.',
      onboardingDocTypeCreateError: 'No se pudo crear el tipo.',
      onboardingDocTypeSaved: 'Tipo actualizado.',
      onboardingDocTypeSaveError: 'No se pudo actualizar el tipo.',
      onboardingDocTypeDeleted: 'Tipo eliminado.',
      onboardingDocTypeDeleteError: 'No se pudo eliminar el tipo.',
      onboardingNewContract: 'Nueva plantilla de contrato',
      onboardingAddContract: 'Añadir plantilla',
      onboardingRefUrlPlaceholder: 'URL de referencia del modelo (opcional)',
      onboardingContractRefUpload: 'Subir archivo',
      onboardingContractRefUploading: 'Subiendo…',
      onboardingContractRefUploadError: 'No se pudo subir el archivo.',
      onboardingContractRefOpen: 'Abrir',
      onboardingContractRefPending: 'Archivo en el servidor — se vinculará al crear la plantilla.',
      onboardingContractInvalid: 'Indique el nombre de la plantilla.',
      onboardingContractCreated: 'Plantilla creada.',
      onboardingContractCreateError: 'No se pudo crear la plantilla.',
      onboardingContractSaved: 'Plantilla actualizada.',
      onboardingContractSaveError: 'No se pudo actualizar la plantilla.',
      onboardingContractDeleted: 'Plantilla eliminada.',
      onboardingContractDeleteError: 'No se pudo eliminar la plantilla.',
      confirmDeleteOnboardingDocType: '¿Eliminar tipo de documento?',
      confirmDeleteOnboardingDocTypeHint: 'Solo permitido si no hay cumplimientos de venta vinculados a este tipo.',
      confirmDeleteOnboardingContract: '¿Eliminar plantilla de contrato?',
      confirmDeleteOnboardingContractHint: 'Solo permitido si no hay cumplimientos de venta vinculados a esta plantilla.',
    },
    paymentForms: {
      isFinancing: 'Financiación',
      isCashPayment: 'Al contado',
      kindHint: 'Clasifique el método para informes y reglas. Solo una de las dos opciones puede estar activa.',
      exclusiveConflict: 'No se puede marcar financiación y al contado al mismo tiempo.',
      badgeFinancing: 'Financiación',
      badgeCash: 'Al contado',
    },
    dealership: {
      pageTitle: 'Configuración del Concesionario',
      pageSubtitle: 'Sucursales, datos fiscales por sucursal y categorías de vehículo',
      vehicleTypes: {
        title: 'Tipos de Vehículos',
        sectionTitle: 'Tipos de Vehículos Aceptados',
        sectionDescription: 'Seleccione los tipos de vehículos con los que trabaja su concesionario. Si no se selecciona ninguno, se muestran todos.',
        saveButton: 'Guardar Tipos de Vehículos',
        saveSuccess: 'Guardado con éxito',
      },
      branch: {
        title: 'Sucursales',
        sectionTitle: 'Sucursales',
        newButton: 'Nueva Sucursal',
        emptyTitle: 'No hay sucursales registradas',
        emptyDescription: 'Haga clic en "Nueva Sucursal" para agregar la primera sucursal.',
        primaryBadge: 'Matriz',
        listVehicleCategories: 'Categorías',
        categoryLabels: {
          A: 'Motocicletas',
          B: 'Automóviles',
          C: 'Camiones',
          D: 'Autobuses',
        },
        form: {
          newTitle: 'Nueva Sucursal',
          editTitle: 'Editar Sucursal',
          createButton: 'Crear Sucursal',
          saveEditButton: 'Guardar Cambios',
          saveError: 'Error al guardar sucursal',
          sectionBranch: 'Identificación',
          sectionContact: 'Contacto',
          sectionAddress: 'Dirección',
          sectionFiscal: 'Fiscal (NF-e / exportación)',
          fiscalHint:
            'IE, régimen tributario y NCM/CFOP por defecto de esta sucursal. En la venta, el vehículo debe estar vinculado a esta sucursal para usar estos datos en el emisor.',
          phoneHint: 'Opcional. Código de área + número.',
          categoriesSection: 'Categorías de vehículo en esta sucursal',
          categoriesHint: 'Defina qué tipos de vehículo se pueden registrar en esta sucursal. Se requiere al menos una categoría.',
          categoriesRequired: 'Seleccione al menos una categoría de vehículo.',
          invalidEmail: 'Ingrese un correo electrónico válido.',
          invalidPhone: 'Ingrese un teléfono válido con código de área (10 u 11 dígitos después del código).',
          zipCodeLookupError: 'No fue posible buscar el código postal informado.',
          zipCodeIncomplete: 'Ingrese el código postal con 8 dígitos antes de buscar.',
          zipSearchButton: 'Buscar código postal',
          zipSearchHint: 'Escriba el código postal y pulse Buscar, o Enter en el campo.',
          searchingZipCode: 'Buscando dirección por código postal...',
          requiredFieldError: 'Campo obligatorio no completado: {{field}}',
          fields: {
            name: 'Nombre de sucursal *',
            phone: 'Teléfono',
            email: 'Correo',
            zipCode: 'Código postal *',
            street: 'Calle *',
            number: 'Número *',
            complement: 'Complemento',
            neighborhood: 'Barrio *',
            city: 'Ciudad *',
            state: 'UF *',
            stateRegistration: 'Inscripción estatal (IE)',
            taxRegime: 'Régimen tributario',
            fiscalDefaultNcm: 'NCM por defecto',
            fiscalDefaultCfop: 'CFOP por defecto',
          },
          placeholders: {
            name: 'Ej: Matriz São Paulo',
            email: 'sucursal@empresa.com',
            street: 'Calle, avenida…',
            number: 'N.º',
            complement: 'Sala, piso…',
            neighborhood: 'Barrio',
            city: 'Ciudad',
          },
        },
      },
      registration: {
        title: 'Registro de empresa',
        subtitle: 'Completa los datos de tu empresa para crear la cuenta administrativa',
        stepTitles: {
          company: 'Datos de la empresa',
          user: 'Usuario administrador',
          payment: 'Confirmación del plan',
        },
        stepDescriptions: {
          company: 'Ingresa el CNPJ y los datos de registro de la empresa',
          user: 'Crea el usuario responsable del acceso',
          payment: 'Revisa la información antes de finalizar',
        },
        company: {
          document: 'Documento de la empresa',
          cpf: 'CPF',
          cnpj: 'CNPJ',
          cnpjPlaceholder: '00.000.000/0000-00',
          cnpjHint: 'Usa el CNPJ de la empresa que será registrada.',
          legalName: 'Razón social',
          legalNamePlaceholder: 'Razón social de la empresa',
          tradeName: 'Nombre comercial',
          tradeNamePlaceholder: 'Nombre comercial de la empresa',
          cpfName: 'Nombre del responsable',
          cpfNamePlaceholder: 'Nombre completo',
          email: 'Correo de la empresa',
          emailPlaceholder: 'contacto@empresa.com',
          phone: 'Teléfono de la empresa',
          phonePlaceholder: '(11) 99999-9999',
          address: 'Dirección de la empresa',
        },
        user: {
          sectionTitle: 'Acceso administrativo',
          sectionSubtitle: 'Define los datos de la persona responsable de la cuenta de la empresa.',
          name: 'Nombre del responsable',
          namePlaceholder: 'Nombre completo',
          email: 'Correo del responsable',
          emailPlaceholder: 'admin@empresa.com',
          password: 'Contraseña del administrador',
          passwordPlaceholder: 'Mínimo 6 caracteres',
          confirmPassword: 'Confirmar contraseña',
          confirmPasswordPlaceholder: 'Confirma tu contraseña',
        },
        payment: {
          selectedPlan: 'Plan seleccionado',
          vehiclesUnlimited: 'Vehículos ilimitados',
          vehicles: '{{count}} vehículos',
          free: 'Gratis',
          perMonth: '/mes',
          companySummary: 'Resumen de la empresa',
          termsTitle: 'Términos y condiciones',
          termsPrefix: 'Al continuar, aceptas nuestros',
          termsLink: 'Términos de uso',
          and: 'y',
          privacyLink: 'Política de privacidad',
        },
        actions: {
          back: 'Volver',
          continue: 'Continuar',
          validating: 'Validando...',
          finish: 'Finalizar registro',
        },
        login: {
          prompt: '¿Ya tienes una cuenta?',
          link: 'Inicia sesión',
        },
        success: {
          noTokenMessage: '¡Empresa registrada con éxito! Inicia sesión para continuar.',
          verificationRequired: '¡Empresa registrada con éxito! Verifica tu correo electrónico para continuar.',
        },
        validation: {
          cpfRequired: 'El CPF es obligatorio',
          cpfLength: 'Ingresa 11 dígitos para el CPF',
          cpfValidating: 'Validando CPF...',
          cpfInvalid: 'CPF inválido',
          cpfValidationError: 'Error al validar el CPF. Inténtalo de nuevo.',
          cnpjRequired: 'El CNPJ es obligatorio',
          cnpjLength: 'Ingresa 14 dígitos para el CNPJ',
          cnpjValidating: 'Validando CNPJ...',
          cnpjInvalid: 'CNPJ inválido',
          cnpjValidationError: 'Error al validar el CNPJ. Inténtalo de nuevo.',
          tooManyRequests: 'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
          legalNameRequired: 'La razón social es obligatoria',
          companyEmailRequired: 'El correo de la empresa es obligatorio',
          invalidEmail: 'Correo inválido',
          phoneRequired: 'El teléfono es obligatorio',
          invalidPhone: 'Teléfono inválido',
          addressRequired: 'Completa la dirección completa (CEP, calle, número, barrio, ciudad y estado).',
          userNameRequired: 'El nombre es obligatorio',
          userEmailRequired: 'El correo es obligatorio',
          passwordRequired: 'La contraseña es obligatoria',
          passwordLength: 'La contraseña debe tener al menos 6 caracteres',
          confirmPasswordRequired: 'La confirmación de contraseña es obligatoria',
          passwordMismatch: 'Las contraseñas no coinciden',
          submitError: 'Error al registrar la empresa. Inténtalo de nuevo.',
          connectionError: 'Error de conexión. Verifica tu internet e inténtalo de nuevo.',
          cpfNameRequired: 'El nombre es obligatorio',
          fieldRequired: 'Obligatorio',
        },
        hero: {
          eyebrow: 'Registro premium',
          title: 'Una experiencia de registro con aspecto de producto serio',
          subtitle:
            'Un flujo guiado en 3 pasos, con un resumen lateral fijo y una jerarquía visual mucho más fuerte para los equipos del concesionario.',
          stats: {
            validationTitle: 'Validación',
            validationValue: 'En tiempo real',
            validationDescription: 'CNPJ, CEP y campos críticos con respuesta inmediata.',
            flowTitle: 'Flujo',
            flowValue: '3 pasos',
            flowDescription: 'Empresa, usuario y confirmación del plan sin fricción.',
            securityTitle: 'Confianza',
            securityValue: 'Cuenta lista',
            securityDescription: 'Revisión clara antes del envío final.',
          },
          bullets: {
            premiumVisualTitle: 'Aspecto premium',
            premiumVisualDescription: 'Más jerarquía, contraste y presencia de marca.',
            guidedFlowTitle: 'Flujo guiado',
            guidedFlowDescription: 'El siguiente paso siempre queda claro para el usuario.',
            trustTitle: 'Más confianza',
            trustDescription: 'Resumen, progreso y revisión reducen el abandono.',
          },
        },
        sidebar: {
          eyebrow: 'Resumen de alta',
          quickSummary: 'Resumen rápido',
          title: 'Todo lo que necesitas para finalizar',
          planActive: 'Plan activo',
          progressLabel: 'Progreso del registro',
          progressValue: '{{current}} de {{total}} pasos',
          planSummary: 'Plan seleccionado',
          planUsers: 'Usuarios incluidos',
          planVehicles: 'Vehículos incluidos',
          usersCount: '{{count}} usuarios',
          usersUnlimited: 'Usuarios ilimitados',
          stepPrefix: 'Paso {{count}}',
          benefits: {
            title: 'Destacados del onboarding',
            fastSetupTitle: 'Inicio más rápido',
            fastSetupDescription: 'La estructura visual guía el registro con menos fricción.',
            protectedAccessTitle: 'Acceso protegido',
            protectedAccessDescription: 'Credenciales y revisión final se presentan con claridad.',
            accountReadyTitle: 'Cuenta lista para operar',
            accountReadyDescription: 'Al finalizar, la estructura inicial ya queda definida.',
          },
        },
        form: {
          eyebrow: 'Registro del concesionario',
        },
        common: {
          notProvided: 'No informado',
        },
      },
    },
  },

  whatsapp: {
    title: 'WhatsApp Business',
    subtitle: 'Configure la integración con WhatsApp Business API para enviar y recibir mensajes',
    newTitle: 'Nueva Configuración',
    editTitle: 'Editar Configuración',
    confirmDelete: '¿Está seguro de que desea eliminar la configuración de WhatsApp?',
    noMessages: 'Aún no hay mensajes',
    typeMessage: 'Escriba un mensaje...',
    downloadMedia: 'Descargar archivo',
    emojiPicker: 'Emojis',
    suggestionTitle: 'Sugerencias para aplicar en el lead',
    suggestionApplying: 'Aplicando...',
    suggestionApplied: 'Interés aplicado en el lead',
    suggestionDismiss: 'Descartar sugerencia y no volver a mostrar',
    suggestionPurchaseIntent: 'Aplicar intención de compra',
    suggestionUsageType: 'Aplicar tipo de uso',
    suggestionVehicleMoment: 'Aplicar momento del vehículo',
    suggestionFinancing: 'Aplicar interés en financiación',
    suggestionTradeIn: 'Aplicar interés en permuta',
    suggestionNotePurchaseIntent: 'Intención de compra detectada en la conversación.',
    suggestionNoteUsageType: 'Tipo de uso detectado en la conversación.',
    suggestionNoteVehicleMoment: 'Momento del vehículo detectado en la conversación.',
    suggestionNoteTradeIn: 'Interés en permuta detectado en la conversación.',
    suggestionNoteFinancing: 'Interés en financiación detectado en la conversación.',
    suggestionKeywords: {
      wantsFinancing: 'financiar|financiacion|financiación|cuotas|credito|crédito|entrada',
      hasTradeIn: 'permuta|cambio|entregar mi auto|trade in|trade-in',
      purchaseIntentUrgent: 'urgente|hoy|esta semana|lo antes posible',
      purchaseIntentResearching: 'investigando|mirando|revisando opciones',
      purchaseIntentComparing: 'comparando|comparar|otras opciones',
      usageTypeUber: 'uber|app de viajes|99',
      usageTypeCommercial: 'comercial|empresa|flota|trabajo',
      usageTypeFamily: 'familia|hijos|niños',
      usageTypePersonal: 'personal|uso propio|uso particular',
      vehicleMomentFirstCar: 'primer auto|primer coche|mi primer vehículo',
      vehicleMomentUpgrade: 'upgrade|mejor auto|subir de categoria',
      vehicleMomentReplacement: 'reemplazar|reposición|cambiar el actual',
    },
    retryAction: 'Reenviar mensaje',
    retryLabel: 'Reenviar',
    retrySent: 'Mensaje reenviado con exito',
    retryMediaUnavailable: 'No fue posible reenviar: medio no disponible',
    status: { active: 'Activo', inactive: 'Inactivo' },
    fields: {
      phoneNumberId: 'Phone Number ID',
      businessAccountId: 'Business Account ID',
      accessToken: 'Access Token',
      webhookVerifyToken: 'Webhook Verify Token',
      isActive: 'Activo',
      autoReply: 'Respuesta automática',
      autoCreateLead: 'Crear lead automáticamente',
      mediaPlaceholder: 'Seleccionar...',
    },
    placeholders: {
      phoneNumberId: 'ID del número de teléfono',
      businessAccountId: 'ID de la cuenta business',
      accessToken: 'Token de acceso de larga duración',
      webhookVerifyToken: 'Token de verificación del webhook',
    },
    actions: { test: 'Probar Conexión', syncTemplates: 'Sincronizar Templates', connectWithMeta: 'Conectar con Meta' },
    messageTypes: { text: 'Texto', image: 'Imagen', video: 'Video', document: 'Documento', template: 'Template' },
    templates: {
      title: 'Templates de Mensaje',
      subtitle: 'Gestione templates aprobados de WhatsApp Business',
      empty: 'Ningún template configurado',
      emptyHint: 'Sincronice los templates de WhatsApp Business o cree nuevos en Meta Business Manager',
      used: 'Usado',
      times: 'veces',
      helpTitle: 'Cómo usar templates',
      help1: 'Los templates son mensajes pre-aprobados por WhatsApp para iniciar conversaciones.',
      help2: 'Cree y apruebe templates en Meta Business Manager antes de usarlos aquí.',
      help3: 'Use el botón "Sincronizar Templates" para importar templates aprobados.',
      sync: 'Sincronizar Plantillas',
      syncHint: 'Haga clic en "Sincronizar Plantillas" para cargar plantillas de Meta',
      usageCount: 'Uso',
    },
    templateStatus: { approved: 'Aprobado', pending: 'Pendiente', rejected: 'Rechazado', inactive: 'Inactivo' },
    templateCategory: { marketing: 'Marketing', utility: 'Utilidad', authentication: 'Autenticación' },
    success: {
      created: '¡Configuración de WhatsApp creada con éxito!',
      updated: '¡Configuración actualizada con éxito!',
      deleted: '¡Configuración eliminada con éxito!',
      tested: '¡Conexión probada con éxito!',
      messageSent: '¡Mensaje enviado con éxito!',
      templatesSynced: '¡Templates sincronizados con éxito!',
      connected: '¡WhatsApp conectado con éxito!',
      disconnected: 'WhatsApp desconectado con éxito',
      oauthConnected: '¡Conectado con éxito a través de Meta!',
    },
    errors: {
      load: 'No se pudo cargar la configuración.',
      required: 'Todos los campos son obligatorios.',
      save: 'No se pudo guardar la configuración.',
      delete: 'No se pudo eliminar la configuración.',
      test: 'Error al probar la conexión.',
      testFailed: 'Prueba de conexión fallida',
      loadMessages: 'No se pudieron cargar los mensajes.',
      sendMessage: 'No se pudo enviar el mensaje.',
      loadTemplates: 'No se pudieron cargar los templates.',
      syncTemplates: 'No se pudieron sincronizar los templates.',
      disconnect: 'Error al desconectar WhatsApp',
      oauthFailed: 'Error al conectar con Meta. Inténtelo de nuevo.',
      reconnect: 'Error al reconectar',
    },
    errorTypes: {
      META_AUTHENTICATION: 'Error de autenticación',
      META_RATE_LIMIT: 'Límite excedido',
      META_BUSINESS_RULE: 'Regla de negocio',
      META_VALIDATION: 'Validación',
      META_COUNTRY_RESTRICTION: 'Restricción de país',
      META_NUMBER_NOT_ALLOWED: 'Número no permitido',
      META_TEMPLATE_NOT_APPROVED: 'Template no aprobado',
      SYSTEM_ERROR: 'Error del sistema',
      INVALID_CONFIG: 'Configuración inválida',
      WHATSAPP_CHANNEL_SESSION_EXPIRED: 'Fuera de la ventana de 24 horas; use un template aprobado',
      WHATSAPP_CONVERSATION_FINALIZED: 'Conversación cerrada; reabra o espere al cliente',
      META_PHONE_NUMBER_UNAVAILABLE:
        'Phone Number ID o token no válidos para Meta — actualice la configuración o reconecte WhatsApp',
    },
    session: {
      templateOnlyBanner:
        'Solo puede enviar templates aprobados. La ventana de 24 h tras el último mensaje del cliente expiró.',
      closedBanner:
        'Conversación cerrada. Reabra para métricas de respuesta o envíe un template aprobado.',
      finalize: 'Cerrar conversación',
      reopen: 'Reabrir conversación',
      finalizedToast: 'Conversación cerrada.',
      reopenedToast: 'Conversación reabierta.',
    },
    help: {
      step1Title: '1. Crear App en Meta Business',
      step1: 'Acceda a developers.facebook.com y cree una app Business. Active la API de WhatsApp Business.',
      step2Title: '2. Obtener Credenciales',
      step2: 'En el panel de la app, vaya a "WhatsApp > API Setup" para obtener Phone Number ID y Access Token permanente.',
      step3Title: '3. Configurar Webhook',
      step3: 'Configure el webhook de WhatsApp para recibir mensajes. Use la URL y token abajo.',
      webhookTitle: 'URL del Webhook',
      webhookUrl: 'URL',
    },
    inbox: {
      title: 'Bandeja de Entrada WhatsApp',
      subtitle: 'Gestione conversaciones y responda mensajes de sus leads',
      conversations: 'Conversaciones',
      searchPlaceholder: 'Buscar por nombre o número...',
      empty: 'Aún no hay conversaciones',
      noResults: 'Ningún resultado encontrado',
      noMessages: 'Sin mensajes',
      selectConversation: 'Seleccione una conversación',
      selectConversationHint: 'Elija una conversación de la lista a la izquierda para comenzar',
      now: 'ahora',
      filters: {
        all: 'Todas',
        unread: 'No leídas',
        today: 'Hoy',
        mine: 'Mías',
      },
      rightPanel: {
        empty: 'Seleccione una conversación para ver datos e inventario.',
        leadSection: 'Contacto',
        noLead: 'Sin lead vinculado a esta conversación.',
        vehicleSearch: 'Buscar vehículo',
        searchVehicles: 'Buscar',
        vehiclesFound: '{{count}} vehículo(s) encontrado(s)',
        expandContactSection: 'Expandir contacto',
        collapseContactSection: 'Contraer contacto',
        expandFiltersSection: 'Expandir filtros',
        collapseFiltersSection: 'Contraer filtros',
        noVehicles: 'Ningún vehículo coincide con los filtros.',
        sendVehicleInfo: 'Enviar resumen por WhatsApp',
        sendPhotos: 'Enviar fotos',
        sendDocuments: 'Enviar documentos',
        confirmSend: 'Enviar',
        confirmPhotosTitle: '¿Enviar fotos por WhatsApp?',
        confirmPhotosBody:
          'Se enviarán hasta 10 fotos del vehículo en secuencia. Las URLs deben ser accesibles por Meta.',
        confirmDocsTitle: '¿Enviar documentos por WhatsApp?',
        confirmDocsBody: 'Los archivos se enviarán uno a uno como documento.',
        success: {
          textSent: 'Resumen del vehículo enviado.',
          photosSent: '{{count}} foto(s) enviada(s).',
          photosPartial: '{{ok}} de {{total}} foto(s) enviadas.',
          docsSent: '{{count}} documento(s) enviado(s).',
          docsPartial: '{{ok}} de {{total}} documento(s) enviados.',
        },
        errors: {
          loadLead: 'No se pudo cargar el lead.',
          loadVehicles: 'No se pudieron cargar vehículos.',
          sendFailed: 'Error al enviar por WhatsApp.',
          noPhotos: 'Este vehículo no tiene fotos.',
          noDocuments: 'Este vehículo no tiene documentos.',
        },
      },
      errors: { loadConversations: 'No se pudieron cargar las conversaciones.' },
    },
    info: {
      dialogTitle: 'Detalles de Integración WhatsApp',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      activeStatus: 'WhatsApp está activo y funcionando',
      inactiveStatus: 'WhatsApp está inactivo',
      noConfig: 'Configuración no encontrada',
      noConfigHint: 'Haga clic en "Conectar" en la página de Marketplace para configurar WhatsApp.',
      lastSync: 'Última Sincronización',
      createdAt: 'Creado en',
      never: 'Nunca',
      configurations: 'Configuraciones',
      autoReplyEnabled: 'Respuesta automática activada',
      autoCreateLeadEnabled: 'Creación automática de leads',
      lastError: 'Último error',
      webhookUrl: 'Webhook URL',
      webhookHint: 'Configure esta URL en el Panel de Meta:',
      reconnect: 'Reconectar',
      reconnecting: 'Reconectando...',
      disconnect: 'Desconectar',
      disconnecting: 'Desconectando...',
      close: 'Cerrar',
      confirmDisconnect: '¿Está seguro que desea desconectar WhatsApp?',
      confirmDisconnectWarning: 'Todos los datos de configuración serán eliminados y necesitará reconectar nuevamente.',
      confirmDisconnectButton: 'Sí, Desconectar',
      processingConnection: 'Procesando conexión...',
    },
    errorHelp: {
      checkMeta: 'Verifique la configuración en Meta Business Manager',
      metaIssue: 'Este es un problema de configuración en Meta Business Manager, no en el sistema.',
      openMetaManager: 'Abrir Meta Business Manager',
    },
  },

  marketplace: {
    title: 'Marketplace',
    subtitle: 'Conecte suas integrações para atraer más leads',
    comingSoon: 'Próximamente',
    comingSoonHint:
      'Esta integración aún no está disponible en esta versión. Por ahora, use Mercado Livre y WhatsApp.',
    connected: 'Conectado',
    notConnected: 'No conectado',
    howToConnect: 'Cómo conectar',
    connect: 'Conectar',
    connecting: 'Conectando...',
    disconnect: 'Desconectar',
    disconnecting: 'Desconectando...',
    reconnect: 'Volver a conectar',
    reconnecting: 'Reconectando...',
    viewDetails: 'Ver Detalles',
    templates: 'Plantillas',
    integrations: {
      whatsapp: {
        name: 'WhatsApp Business',
        description: 'Conecta WhatsApp Business para recibir y enviar mensajes, crear leads automáticamente y administrar plantillas.',
        helpText: 'Se requiere una cuenta de WhatsApp Business API aprobada por Meta.',
      },
      meta: {
        name: 'Meta',
        description: 'Conecta tu Instagram y Facebook Business para recibir leads automáticamente.',
        helpText: 'Se requiere una cuenta de Facebook Business y una página profesional de Instagram.',
      },
      mercadolivre: {
        name: 'Mercado Livre',
        description: 'Publica tus vehículos automáticamente y recibe mensajes de compradores.',
        helpText: 'Se requiere una cuenta de vendedor de Mercado Livre y una aplicación aprobada.',
        title: 'Mercado Livre',
        oauthConnected: 'Cuenta de Mercado Livre vinculada con éxito.',
        notConfigured: 'Mercado Livre aún no está configurado.',
        active: 'La integración está activa y funcionando.',
        accountInfo: 'Información de la cuenta',
        userId: 'ID de usuario',
        connectedAt: 'Conectado el',
        lastSync: 'Última sincronización',
        lastError: 'Último error',
        disconnect: {
          title: 'Desconectar Mercado Livre',
          warning:
            'Al desconectar, no podrás publicar ni sincronizar anuncios hasta vincular la cuenta de nuevo.',
        },
        errors: {
          load: 'No se pudo cargar el estado de Mercado Livre.',
          reconnect: 'No se pudo iniciar la reconexión.',
          disconnect: 'No se pudo desconectar Mercado Livre.',
          notFound: 'No se encontró ninguna integración de Mercado Livre.',
        },
      },
      olx: {
        name: 'OLX',
        description: 'Promociona tus vehículos en la mayor plataforma de clasificados de Brasil.',
        helpText: 'Requiere cuenta profesional de OLX y aprobación del anuncio.',
      },
    },

    success: {
      connected: '¡Integración conectada con éxito!',
      disconnected: '¡Integración desconectada con éxito!',
    },

    errors: {
      connect: 'Error al conectar',
      unknown: 'Error desconocido',
    },

    publications: {
      title: 'Publicaciones',
      subtitle: 'Gestiona la publicación de vehículos en marketplaces',
      selectMarketplace: 'Selecciona el marketplace',
      searchVehicles: 'Buscar vehículos...',
      publish: 'Publicar',
      publishing: 'Publicando...',
      selectAtLeastOne: 'Selecciona al menos un vehículo',
      selectAll: 'Seleccionar Todos',
      deselectAll: 'Deseleccionar Todos',
      availableVehicles: 'Vehículos Disponibles',
      vehicle: 'Vehículo',
      year: 'Año',
      price: 'Precio',
      status: 'Estado',
      publishedOn: 'Publicado En',
      actions: 'Acciones',
      history: 'Historial',
      notPublished: 'No publicado',
      success: '{{queued}} vehículos enviados para publicación. {{failed}} fallaron.',
      error: 'Error al publicar vehículos',
      autoPublish: {
        title: 'Publicación Automática',
        enabled: 'Activada',
        disabled: 'Desactivada',
        enable: 'Activar publicación automática',
        disable: 'Desactivar publicación automática',
        description: 'Los vehículos se publicarán automáticamente en los horarios de procesamiento del marketplace',
        scheduleInfo: 'Horarios de Procesamiento',
        scheduleDescription: 'Los marketplaces procesan publicaciones en horarios específicos para mejor rendimiento',
        error: 'Error al actualizar la publicación automática',
      },
    },

    history: {
      title: 'Historial de Publicaciones',
      subtitle: 'Sigue todas las publicaciones',
      filterByMarketplace: 'Filtrar por Marketplace',
      filterByStatus: 'Filtrar por Estado',
      allMarketplaces: 'Todos los Marketplaces',
      allStatuses: 'Todos los Estados',
      vehicle: 'Vehículo',
      marketplace: 'Marketplace',
      status: 'Estado',
      publishedAt: 'Publicado en',
      createdAt: 'Creado en',
      updatedAt: 'Actualizado en',
      actions: 'Acciones',
      viewAd: 'Ver Anuncio',
      noPublications: 'No se encontraron publicaciones',
      error: 'Error al cargar historial',
      page: 'Página',
      of: 'de',
      previous: 'Anterior',
      next: 'Siguiente',
      statusTypes: {
        PENDING: 'Pendiente',
        PUBLISHED: 'Publicado',
        FAILED: 'Fallado',
        UPDATING: 'Actualizando',
        PAUSED: 'Pausado',
        REMOVED: 'Removido',
      },
    },

    logs: {
      title: 'Historial',
      loadingHistory: 'Cargando historial...',
      noPublications: 'No se encontraron publicaciones para este vehículo',
      viewAd: 'Ver Anuncio',
      eventHistory: 'Historial de Eventos',
      noEvents: 'No hay eventos registrados',
      attempt: 'Intento',
      hideDetails: 'Ocultar detalles',
      showDetails: 'Ver detalles',
      errorDetails: 'Detalles del Error:',
      apiResponse: 'Respuesta de la API:',
      error: 'Error al cargar historial',
      actions: {
        CREATED: 'Creado',
        QUEUED: 'En Cola',
        PROCESSING: 'Procesando',
        PUBLISHED: 'Publicado',
        UPDATED: 'Actualizado',
        FAILED: 'Fallado',
        RETRYING: 'Reintentando',
        REMOVED: 'Removido',
        ERROR: 'Error',
      },
    },
  },

  // Conversations
  conversations: {
    title: 'Conversaciones',
    searchPlaceholder: 'Buscar conversaciones...',
    noConversations: 'No se encontraron conversaciones',
    selectConversation: 'Seleccionar una conversación',
    selectConversationHint: 'Elige una conversación de la lista para comenzar',
    selectToViewContext: 'Selecciona una conversación para ver el contexto',
    back: 'Volver',
    lastActivity: 'Última actividad',
    messagePlaceholder: 'Escribe tu mensaje...',
    messageSent: 'Mensaje enviado con éxito',
    attachment: 'Adjuntar archivo',
    emoji: 'Agregar emoji',
    quickTemplate: 'Plantilla rápida',
    noteAdded: 'Nota agregada con éxito',
    tagAdded: 'Etiqueta agregada con éxito',

    filters: {
      all: 'Todas',
      unread: 'No Leídas',
      mine: 'Mías',
      hot: 'Calientes',
      today: 'Hoy',
      tags: 'Etiquetas',
    },

    metrics: {
      title: 'Métricas',
      subtitle: 'Últimos 30 días',
      expand: 'Expandir métricas',
      collapse: 'Contraer métricas',
      avgResponseTime: 'Tiempo promedio de respuesta',
      responseRate: 'Tasa de respuesta',
      conversionRate: 'Tasa de conversión',
      noData: '—',
      lessThanMinute: '< 1 min',
      minutes: '{{count}} min',
      hours: '{{count}} h',
      hoursMinutes: '{{hours}} h {{minutes}} min',
    },

    actions: {
      newConversation: 'Nueva conversación',
    },

    quickActions: {
      title: 'Acciones rápidas',
      createProposal: 'Crear propuesta',
      scheduleTestDrive: 'Agendar prueba de manejo',
      linkVehicle: 'Vincular vehículo',
      editLead: 'Editar lead',
      addSelectedVehicleInterest: 'Agregar vehículo seleccionado a intereses',
    },

    success: {
      newConversationCreated: 'Conversación lista. Puede responder abajo.',
    },

    leadData: {
      title: 'Datos del Lead',
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      source: 'Origen',
      notes: 'Notas',
      condition: 'Condición',
      fuelType: 'Combustible',
      transmission: 'Transmisión',
      minPrice: 'Precio mín.',
      maxPrice: 'Precio máx.',
      minYear: 'Año mín.',
      maxYear: 'Año máx.',
      editLead: 'Editar lead',
      cancelEdit: 'Cancelar edición',
      save: 'Guardar datos del lead',
      saving: 'Guardando...',
      updated: 'Datos del lead actualizados',
      updateError: 'Error al actualizar datos del lead',
      historyTitle: 'Historial',
      historyEmpty: 'No hay actividad registrada',
    },

    leadScore: {
      title: 'Puntuación del Lead',
      classification: 'Clasificación',
      hot: 'Caliente',
      warm: 'Templado',
      cold: 'Frío',
    },

    vehicleInterest: {
      title: 'Interés',
      price: 'Precio',
      viewStock: 'Ver Inventario',
    },

    activity: {
      title: 'Actividad',
      noActivity: 'No hay actividad registrada',
    },

    notes: {
      title: 'Notas',
      placeholder: 'Escribe tu nota...',
      add: 'Agregar',
      cancel: 'Cancelar',
      noNotes: 'No se han agregado notas',
    },

    tags: {
      title: 'Etiquetas',
      noTags: 'No se han agregado etiquetas',
    },
    errors: {
      configure: 'Configurar WhatsApp',
      loadError: 'Error al cargar conversaciones',
      loadLeadError: 'Error al cargar datos del lead',
      loadTemplatesError: 'Error al cargar plantillas',
      notConfigured: 'WhatsApp no configurado',
      notConfiguredDesc: 'Configure WhatsApp antes de usar las conversaciones',
      sendError: 'Error al enviar mensaje',
    },
    newConversation: {
      conversationStarted: '¡Conversación iniciada! Envíe el primer mensaje usando una plantilla.',
      createLead: 'Crear Lead',
      createLeadError: 'Error al crear lead',
      createNewLead: 'Crear Nuevo Lead',
      email: 'Correo electrónico',
      emailPlaceholder: 'Ingrese el correo electrónico',
      fillAllParameters: 'Complete todos los parámetros',
      initialMessage: 'Mensaje inicial (opcional)',
      initialMessagePlaceholder: 'Escriba un mensaje inicial...',
      leadCreated: 'Lead creado con éxito',
      leadNoPhone: 'Este lead no tiene un teléfono registrado',
      name: 'Nombre',
      namePlaceholder: 'Ingrese el nombre',
      nameRequired: 'El nombre es obligatorio',
      new: 'Nueva Conversación',
      noLeadsFound: 'No se encontraron leads',
      orCreateNew: 'O cree un nuevo lead',
      parameter: 'Parámetro',
      parameters: 'Parámetros',
      phone: 'Teléfono',
      phonePlaceholder: 'Ingrese el teléfono',
      phoneRequired: 'El teléfono es obligatorio',
      preview: 'Vista previa',
      searchLead: 'Buscar lead',
      searchPlaceholder: 'Escriba el nombre del lead...',
      selectLeadFirst: 'Seleccione un lead primero',
      selectTemplate: 'Seleccionar Plantilla',
      selectTemplateFirst: 'Seleccione una plantilla primero',
      selectTemplatePlaceholder: 'Elija una plantilla...',
      sendAndStart: 'Enviar e Iniciar',
      source: 'Origen',
      startConversation: 'Iniciar Conversación',
      startError: 'Error al iniciar conversación',
      templateNote: 'El primer mensaje debe ser una plantilla aprobada por Meta. Después de abrir la conversación, haga clic en "Seleccionar Plantilla" para enviar.',
      templateSent: 'Plantilla enviada con éxito',
      title: 'Nueva Conversación',
    },
    quickTemplates: {
      greeting: 'Saludo',
      proposal: 'Propuesta',
      scheduling: 'Programación',
      title: 'Plantillas Rápidas',
    },
    templates: {
      availableTemplates: 'Plantillas Disponibles',
      categories: {
        AUTHENTICATION: 'Autenticación',
        MARKETING: 'Marketing',
        UTILITY: 'Utilidad',
      },
      category: 'Categoría',
      createNewTemplate: 'Crear Nueva Plantilla en Meta',
      errors: {
        invalidParameters: 'Parámetro inválido',
        invalidParametersHint: 'Verifique que haya completado todos los campos obligatorios',
        loadError: 'Error al cargar plantillas',
        notFound: 'Plantilla no encontrada',
        notFoundHint: 'Sincronice las plantillas en la configuración',
        sendError: 'Error al enviar plantilla',
        syncError: 'Error al sincronizar plantillas',
      },
      language: 'Idioma',
      noTemplates: 'No hay plantillas disponibles',
      parameters: 'Parámetros',
      preview: 'Vista previa',
      searchPlaceholder: 'Buscar plantilla...',
      selectTemplate: 'Seleccionar Plantilla',
      status: {
        APPROVED: 'Aprobada',
        PENDING: 'Pendiente',
        REJECTED: 'Rechazada',
      },
      templateSent: 'Plantilla enviada con éxito',
      useTemplate: 'Usar Plantilla',
    },
    window24h: {
      active: 'Ventana de 24h activa',
      expired: 'Ventana de 24h vencida',
      expiresIn: 'La ventana de 24h vence en',
      hours: 'h',
      minutes: 'm',
      mustSendTemplate: 'Debe enviar una plantilla primero',
      needsTemplate: 'Envíe una plantilla para reabrir',
      newConversation: 'Esta es una conversación nueva',
      selectTemplateButton: 'Seleccionar Plantilla',
    },
  },

  billing: {
    title: 'Suscripción y facturación',
    subtitle: 'Gestione su plan, pagos e historial de facturas',
    settingsCardTitle: 'Suscripción y facturación',
    settingsCardDescription: 'Plan actual, upgrade, método de pago y facturas',
    currentPlan: 'Plan actual',
    currentPlanBadge: 'Plan actual',
    plansTitle: 'Planes disponibles',
    plansSubtitle: 'Compare y haga upgrade de su plan',
    invoicesTitle: 'Historial de pagos',
    invoicesSubtitle: 'Facturas de la suscripción',
    noInvoices: 'Aún no hay facturas.',
    invoiceDate: 'Fecha',
    invoiceAmount: 'Importe',
    invoiceStatus: 'Estado',
    invoicePaidAt: 'Pagado el',
    viewInvoice: 'Ver factura',
    nextPayment: 'Próximo pago',
    lastPayment: 'Último pago',
    trialEnd: 'Fin del trial',
    monthly: 'Mensual',
    yearly: 'Anual',
    month: 'mes',
    year: 'año',
    managePayment: 'Configurar pago',
    completePayment: 'Completar pago',
    upgradePlan: 'Hacer upgrade',
    cancelSubscription: 'Cancelar suscripción',
    cancelConfirm: '¿Cancelar la suscripción al final del período actual?',
    cancelScheduled: 'Cancelación programada para el fin del período.',
    cancelAtPeriodEnd: 'Cancela al fin del período',
    checkoutSuccess: 'Pago configurado correctamente.',
    checkoutCancelled: 'Checkout cancelado. No se realizaron cambios.',
    planChanged: 'Plan actualizado correctamente.',
    noSubscriptionTitle: 'Suscripción no encontrada',
    noSubscriptionDescription: 'Contacte soporte o elija un plan abajo para activar la facturación.',
    status: {
      incomplete: 'Pago pendiente',
      trialing: 'Período de prueba',
      active: 'Activa',
      past_due: 'Pago atrasado',
      canceled: 'Cancelada',
      unpaid: 'No pagada',
    },
    errors: {
      load: 'Error al cargar la suscripción',
      portal: 'No se pudo abrir el portal de pago',
      changePlan: 'Error al cambiar el plan',
      downgrade: 'No se puede hacer downgrade: límites excedidos',
      cancel: 'Error al cancelar la suscripción',
      noSubscription: 'Suscripción no configurada',
      samePlan: 'Este ya es su plan actual',
      ownerOnlyPortal: 'Solo el propietario puede cambiar el método de pago en el portal.',
    },
  },

  ui: {
    languageSwitcher: {
      triggerLabel: 'Seleccionar idioma',
      triggerTitle: 'Abrir selector de idioma',
      languages: {
        pt: 'Portugués',
        en: 'Inglés',
        es: 'Español',
      },
    },
  },

  notFound: {
    title: 'Página no encontrada',
    message: 'La página que busca no existe o fue movida.',
    backToDashboard: 'Volver al panel',
    backToPlans: 'Ver planes',
  },

  publicPlans: {
      hero: {
        eyebrow: 'Planes',
        title: 'Elige el plan ideal para tu concesionario',
        subtitle:
          'Compara límites y recursos, elige facturación mensual o anual y continúa al registro.',
        trust1: 'Sin permanencia',
        trust2: 'Activación inmediata',
        trust3: 'Soporte incluido',
        alreadyHaveAccount: '¿Ya tienes una cuenta?',
        loginLink: 'Iniciar sesión',
      },
      summary: {
        title: 'Resumen de la selección',
        subtitle: 'Revisa el plan antes de avanzar.',
        priceLabelMonthly: '/mes',
        priceLabelYearly: '/año',
        selectedPlan: 'Plan elegido',
        hint: 'Selecciona un plan para continuar',
      },
      actions: {
        continue: 'Continuar',
        selectPlan: 'Seleccionar plan',
        selected: 'Seleccionado',
      },
      comparison: {
        title: 'Comparación de funciones',
        resources: 'Funciones',
      },
      badges: {
        mostPopular: 'Más popular',
        saveUpTo: 'Ahorra hasta {{discount}}%',
      },
      features: {
        vehicles: 'Vehículos',
        users: 'Usuarios',
        leads: 'Leads',
        support: 'Soporte',
        analytics: 'Analytics',
        customization: 'Personalización',
        apiAccess: 'Acceso a la API',
        multipleLocations: 'Múltiples ubicaciones',
        unlimited: 'Ilimitado',
        supportLevels: {
          none: 'Ninguno',
          email: 'Correo electrónico',
          priority: 'Prioritario',
          dedicated: 'Dedicado',
        },
        analyticsLevels: {
          none: 'Ninguno',
          basic: 'Básico',
          advanced: 'Avanzado',
          custom: 'Personalizado',
        },
      },
      billing: {
        monthly: 'Mensual',
        yearly: 'Anual',
      },
      errors: {
        title: 'No se pudieron cargar los planes',
        retry: 'Intentar de nuevo',
        loading: 'Cargando planes…',
      },
    },

  publicOnboarding: {
      stepTitles: {
        config: 'Acceso y configuración',
        summary: 'Revisión final',
      },
      stepDescriptions: {
        config: 'Crea el acceso administrativo y ajusta lo básico fiscal.',
        summary: 'Revisa la información antes de finalizar.',
      },
    },

  auth: {
    login: {
      title: 'Inicia sesión en tu cuenta',
      subtitle: 'ambcar · Gestión de Concesionarios',
      email: 'Correo electrónico',
      emailPlaceholder: 'tu@correo.com',
      password: 'Contraseña',
      passwordPlaceholder: '••••••••',
      rememberMe: 'Recuérdame',
      forgotPassword: '¿Olvidaste tu contraseña?',
      submit: 'Entrar',
      submitting: 'Entrando...',
      noAccount: '¿No tienes cuenta?',
      registerLink: 'Registra tu empresa',
      needHelp: '¿Necesitas ayuda?',
      contactUs: 'Contáctanos',
      brand: {
        headline: 'La plataforma completa para gestión de concesionarios',
        text1: 'Gestiona tu inventario con inteligencia y velocidad',
        text2: 'Leads calificados, cierres más rápidos',
        text3: 'Visibilidad total de tu pipeline de ventas',
        text4: 'Automatiza procesos, enfócate en resultados',
        text5: 'Decisiones comerciales más rápidas, operación más eficiente',
        feature1: 'Gestión completa de inventario automotriz',
        feature2: 'Pipeline de ventas en tiempo real',
        feature3: 'Integración de WhatsApp y CRM nativo',
      },
      errors: {
        invalidCredentials: 'Correo o contraseña incorrectos',
        invalidCredentialsMsg: 'Las credenciales proporcionadas no coinciden con nuestros registros.',
        invalidCredentialsSuggestion: 'Verifica que hayas escrito tu correo y contraseña correctamente. Las contraseñas distinguen mayúsculas y minúsculas.',
        accessBlocked: 'Acceso bloqueado',
        accessBlockedMsg: 'Tu cuenta está bloqueada o no tienes permiso para acceder a este sistema.',
        accessBlockedSuggestion: 'Contacta al administrador de tu concesionario o a nuestro equipo de soporte para más información.',
        connectionError: 'Error de conexión',
        connectionErrorMsg: 'No se pudo establecer conexión con el servidor.',
        connectionErrorSuggestion: 'Verifica tu conexión a internet e inténtalo de nuevo. Si el problema persiste, nuestros servidores pueden estar en mantenimiento.',
        timeout: 'Tiempo de espera agotado',
        timeoutMsg: 'La solicitud tardó demasiado en procesarse.',
        timeoutSuggestion: 'Esto puede indicar inestabilidad en la conexión. Espera unos segundos e inténtalo de nuevo.',
        serverError: 'Servidor temporalmente no disponible',
        serverErrorMsg: 'Nuestros servidores están experimentando problemas técnicos en este momento.',
        serverErrorSuggestion: 'Nuestro equipo ya fue notificado. Por favor, inténtalo de nuevo en unos minutos.',
        tooManyAttempts: 'Demasiados intentos de inicio de sesión',
        tooManyAttemptsMsg: 'Has excedido el número máximo de intentos de inicio de sesión.',
        tooManyAttemptsSuggestion: 'Por seguridad, espera 15 minutos antes de intentarlo de nuevo.',
        generic: 'Error al iniciar sesión',
        genericMsg: 'Ocurrió un error inesperado al intentar iniciar sesión.',
        genericSuggestion: 'Verifica tus credenciales e inténtalo de nuevo. Si el problema persiste, contacta al soporte.',
      },
      forgotPasswordInfo: 'Recuperación de contraseña',
      forgotPasswordInfoMsg: 'Funcionalidad en desarrollo.',
      forgotPasswordInfoSuggestion: 'Contacta al administrador de tu concesionario o a nuestro equipo de soporte para restablecer tu contraseña.',
    },
    verifyEmail: {
      loginRequiredMessage: 'Tu correo electrónico necesita ser verificado antes de iniciar sesión. Revisa tu bandeja de entrada para encontrar el código.',
      title: 'Verifica tu correo electrónico',
      subtitle: 'Enviamos un código de 6 dígitos a',
      instruction: 'Ingresa el código de verificación',
      placeholder: '0',
      submit: 'Verificar',
      submitting: 'Verificando...',
      resend: 'Reenviar código',
      resending: 'Reenviando...',
      resendIn: 'Reenviar en {{seconds}}s',
      expiresIn: 'El código expira en',
      expired: 'El código ha expirado',
      minutes: '{{minutes}} min',
      seconds: '{{seconds}}s',
      backToLogin: 'Volver al inicio de sesión',
      didNotReceive: '¿No recibiste el código?',
      checkSpam: 'Revisa también tu carpeta de spam',
      brand: {
        headline: '¡Casi listo!',
        text1: 'Estamos verificando tu identidad para proteger tu cuenta',
        text2: 'La verificación de correo garantiza la seguridad de tus datos',
        text3: 'En instantes tendrás acceso completo a la plataforma',
        feature1: 'Protección avanzada de tu cuenta',
        feature2: 'Acceso seguro a los datos del concesionario',
        feature3: 'Cumplimiento con buenas prácticas de seguridad',
      },
      success: {
        title: '¡Correo verificado!',
        message: 'Tu correo ha sido verificado exitosamente. Ya puedes acceder a tu cuenta.',
      },
      errors: {
        invalidCode: 'Código inválido',
        invalidCodeMsg: 'El código de verificación ingresado no es válido.',
        invalidCodeSuggestion: 'Asegúrate de haber ingresado correctamente los 6 dígitos del código recibido por correo.',
        expiredCode: 'Código expirado',
        expiredCodeMsg: 'El código de verificación ha expirado.',
        expiredCodeSuggestion: 'Haz clic en "Reenviar código" para recibir un nuevo código de verificación.',
        notFound: 'Código no encontrado',
        notFoundMsg: 'No se encontró ningún código de verificación para este correo.',
        notFoundSuggestion: 'Haz clic en "Reenviar código" para solicitar uno nuevo.',
        alreadyVerified: 'Correo ya verificado',
        alreadyVerifiedMsg: 'Este correo ya ha sido verificado anteriormente.',
        generic: 'Error de verificación',
        genericMsg: 'Ocurrió un error al verificar el código.',
        genericSuggestion: 'Inténtalo de nuevo. Si el problema persiste, solicita un nuevo código.',
        resendFailed: 'Error al reenviar',
        resendFailedMsg: 'No se pudo reenviar el código de verificación.',
        resendFailedSuggestion: 'Verifica tu conexión e inténtalo de nuevo en unos instantes.',
      },
    },
  },
  postSalesPipeline: {
    subtitle: 'Ventas en posventa con flujo guiado hasta el envío a preparación.',
    title: 'Embudo de ventas',
    wizard: {
      backToList: 'Volver a la lista',
      nextPhase: 'Ir a la siguiente fase',
      persistStepError: 'No fue posible actualizar la etapa de la venta.',
      stepBack: 'Etapa anterior',
    },
  },
}
